import { downloadExcel } from '@store/excel.reducer'
import API from './apiCreate'
import { getHeaders } from './getHeaders'
import { getParams } from './getParams'
import axios from 'axios'
import { ensureApiSuccess } from '../helpers/ensureApiSuccess'
export { API }
export * from './queries/index'
export * from './crm-integrations'
export * from './integrations'
export * from './crm-call-analysis/crm-call-analysis.api'
export * from './crm-call-analysis/crm-call-analysis.types'
export * from './notification-delivery-target'
export * from './email-confirmation'
export * from './email-provider-integration'

const cancelToken = {
  groupSeminarian: null,
  groupOverview: null,
  getWorks: null,
  getUsers: null,
  timetableChangePlan: null,
  timetableGetData: null,
  getCourseBlocks: null,
  getWorkingHoursEmployees: null,
  getFreeOrBusyWorkingHoursEmployees: null,
  updateChatTitle: null,
}

const deletionConfirmationConfig = (confirmation) => ({
  ...getHeaders(),
  data: { confirmation },
  skipGlobalErrorAlert: true,
})

export const usersAPI = {
  create: (conf) => API.post('user/create', conf.data, getHeaders()),
  getUsers: ({ params, ...conf }) =>
    API.get(`user/${getParams(conf)}`, getHeaders()),
  getUsersCancel: ({ params, cancelTokenSource, ...conf }) => {
    if (cancelToken.getUsers)
      cancelToken.getUsers.cancel(
        'Previous request canceled due to new request.',
      )

    cancelToken.getUsers = cancelTokenSource ?? axios.CancelToken.source()

    return API.get(`user/${getParams(conf)}`, {
      headers: getHeaders().headers,
      cancelToken: cancelToken.getUsers.token, // Передаем токен отмены здесь
    })
  },
  getUser: (conf, cancelToken) =>
    API.get(`user/view/${conf.id}${getParams(conf)}`, {
      ...getHeaders(),
      cancelToken: cancelToken?.token,
    }),
  getNameById: (conf, cancelToken) =>
    API.get(`user/get-name-by-id${getParams(conf)}`, {
      ...getHeaders(),
      cancelToken: cancelToken?.token,
    }),
  // getNameById: (conf, cancelToken) =>
  //   API.get(`user/get-name-by-id${getParams(conf)}`, {
  //     ...getHeaders(),
  //     cancelToken: cancelToken?.token
  //   }),
  upd: (conf, config = getHeaders()) =>
    API.put(`user/update/${conf.id}`, conf.data, config),
  disable: (conf) =>
    API.put(`user/disable/${conf.id}`, conf.data, getHeaders()),
  restore: (conf) =>
    API.put(`user/restore/${conf.id}`, conf.data, getHeaders()),
  setStatus: (conf) =>
    API.put(`user/set-status/${conf.id}`, conf.data, getHeaders()),
  updateBalance: (conf) =>
    API.put(`user/update-balance/${conf.id}`, conf.data, getHeaders()),
  addContract: (conf) =>
    API.post('user/upload-contract', conf.data, getHeaders(['FormData'])),
  removeContract: (conf) =>
    API.delete(`user/delete-contract/${conf.id}`, conf.data, getHeaders()),
  updAvatar: (conf) =>
    API.post(
      `user/update-avatar/${conf.id}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  register: (body) => API({ url: `user/signup`, ...body, method: 'POST' }),
  registerLinkedStep: (body) =>
    API({ url: `user/signup`, ...body, method: 'PUT' }),
  signupVk: (body) => API.post(`auth/signup-vk`, body),
  changePassword: (conf) =>
    API.post(`user/change-password/${conf.id}`, conf.data, getHeaders()),
  restorePassword: (body) => API.post(`auth/restore-password`, body),
  resetPassword: (conf) =>
    API.post(`user/reset-password/${conf.id}`, conf.data, getHeaders()),
  getStudents: ({ params }) =>
    API.get(`user/get-students-by-direction`, params),
  getChildren: (params = {}) =>
    API.get(`user/get-children${getParams(params)}`, getHeaders()),

  sendDocumentForVerification: (body) =>
    API.post(`user/document-verification`, body, getHeaders(['FormData'])),

  getSeminarian: (conf) =>
    API.get(
      `user/seminarians-by-direction?directionId=${
        conf.direction_id
      }${getParams(conf, false)}`,
    ),
  addDirection: ({ data, params }) =>
    API({ url: `user/add-direction`, data, params, method: 'post' }),
  changeDirection: ({ id, data }) =>
    API.post(`user/change-direction?id=${id}`, data),
  directionBySeminarian: ({ id, params }, cancelToken) =>
    API({
      url: `user/directions-by-seminarian?seminarianId=${id}`,
      params,
      method: 'GET',
      cancelToken: cancelToken?.token,
    }),
  removeDirection: ({ id }) =>
    API({ url: `user/delete-direction?id=${id}`, method: 'DELETE' }),
  prevDirectionOrder: (params) =>
    API({
      url: `user/get-prev-direction-order`,
      params,
      method: 'GET',
    }),

  studentsRating: (body) => API({ url: `user/students-rating`, ...body }),
  seminarianByDirection: ({ id }) =>
    API({
      url: `user/get-user-by-direction/?directionId=${id}&expand=seminarian`,
      method: 'GET',
    }),
  switchRole: (role) => API.post('user/switch-role', { role }),
  updateRoles: ({ id, data }) =>
    API.put(`user/update-roles/${id}`, data, getHeaders()),
  authorization: (id) => API.get(`user/authorization/${id}`),
  authorizationByCustomId: (customId) =>
    API.get(`user/authorization-by-custom-id?custom_id=${customId}`),
  updateSupervisorResponsibilities: ({ id, data }) =>
    API.post(
      `user/update-supervisor-responsibilities/${id}`,
      data,
      getHeaders(),
    ),
  getUserFiles: (params = '') => API.get(`user-files/${params}`, getHeaders()),
  getUserFileUsages: (ids = []) =>
    API.get(`user-files/usages?ids=${ids.join(',')}`, getHeaders()),
  getUserFile: (id) => API.get(`user-files/get-file-by-id/${id}`),
  getMediaFolders: () => API.get('user-files/folders'),
  createMediaFolder: (title) => API.post('user-files/create-folder', { title }),
  setMediaFolder: (id, folderId) =>
    API.post(`user-files/set-folder/${id}`, { folder_id: folderId }),
  uploadPlatformMedia: (body, config) =>
    API.post(`user-files/save-file`, body, {
      ...config,
      headers: getHeaders(['FormData']),
    }),
  updatePlatformMedia: (body, config) =>
    API.post(`user-files/update-file`, body, {
      ...config,
      headers: getHeaders(['FormData']),
    }),
  deletePlatformMedia: (body) =>
    API.post(`user-files/delete-file`, body, getHeaders(['FormData'])),
  getColleaguesForGroup: (params) =>
    API.get(`user/colleagues-for-group${getParams(params)}`),
  checkEmail: (email, courseId, classId, isParent) => {
    const params = new URLSearchParams()
    if (email) params.append('email', email)
    if (courseId) params.append('course_id', courseId)
    if (classId) params.append('class_id', classId)
    if (isParent) params.append('is_parent', isParent)
    return API.get(`user/check-email?${params.toString()}`)
  },

  checkPhone: (phone, courseId, classId, isParent) => {
    const params = new URLSearchParams()
    if (phone) params.append('phone', phone)
    if (courseId) params.append('course_id', courseId)
    if (classId) params.append('class_id', classId)
    if (isParent) params.append('is_parent', isParent)
    return API.get(`user/check-email?${params.toString()}`)
  },
  checkLogin: (login) => {
    const params = new URLSearchParams()
    if (login) params.append('login', login)
    return API.get(`user/check-email?${params.toString()}`)
  },
  createParent: (data) => API.post('user/create-parent', data, getHeaders()),
  searchUsersForSelect: (params) =>
    API.get(`user/search-for-select/${getParams(params)}`, getHeaders()),
  getWorkingHoursEmployees: (params) => {
    if (cancelToken.getWorkingHoursEmployees) {
      cancelToken.getWorkingHoursEmployees.cancel(
        'Previous request canceled due to new request.',
      )
    }

    cancelToken.getWorkingHoursEmployees = axios.CancelToken.source()

    return API.get(`user/get-working-hours-employees/${getParams(params)}`, {
      headers: getHeaders().headers,
      cancelToken: cancelToken.getWorkingHoursEmployees.token,
    })
  },
  getBalanceOfAdditionalActivities: (params, cancelToken) =>
    API.get(`user/get-balance-of-additional-activities/${getParams(params)}`, {
      ...getHeaders(),
      cancelToken: cancelToken?.token,
    }),
  setBalanceAdditionalActivities: (body) =>
    API.post('user/set-balance-of-additional-activities', body),
  getConnectedUsers: (params) =>
    API.get(`user/get-connected-users${getParams(params)}`),
  disconnectAccount: (params) =>
    API.get(`user/disconnect-account${getParams(params)}`),
  connectAccount: (body) => API.post('user/connect-account', body),
  authorizationMobile: (params) =>
    API.get(`user/authorization-mobile${getParams(params)}`),
  getCustomCoursePrice: (params) =>
    API.get(`user/custom-course-price${getParams(params)}`),
}

export const profileAPI = {
  login: ({ email, password }) =>
    API.post(
      'auth/login/?expand=roles',
      { password, email },
      { withCredentials: true },
    ),
  confirmTwoFactorLogin: (data) =>
    API.post(
      'auth/login/confirm-code/?expand=roles',
      data,
      { withCredentials: true },
    ),
  // отправить в Redux
  // 2-ой енд поинт
  appLogin: ({ app_id, uuid }) =>
    API.post(
      'auth/login/?expand=roles',
      { type: 'app', app_id, uuid },
      { withCredentials: true },
    ),
  getUniversity2035Config: () =>
    API.get('auth/university2035-config', { skipGlobalErrorAlert: true }),
}

export const staticDataAPI = {
  getRole: () => API.get('user/roles', getHeaders()),
}

export const thematicsAPI = {
  getAll: (body) =>
    API({
      url: `direction-filter`,
      ...body,
      params: { ...body?.params, pageSize: false },
    }),
  // getAllSubFolders: (body) =>
  //   API({
  //     url: `direction-filter/get-subfolders`,
  //     ...body,
  //     params: { ...body?.params, pageSize: false },
  //   }),
  getAllSubFolders: (body) =>
    API.get(
      `direction-filter/get-subfolders`,
      { ...body?.params, pageSize: false },
      getHeaders(),
    ),
  getAllNotEmpty: (body) =>
    API({
      url: `direction-filter/folders-not-empty`,
      ...body,
      params: { ...body?.params, pageSize: false },
    }),
  getAllSubFoldersNotEmpty: (body) =>
    API.get(
      `direction-filter/subfolders-not-empty`,
      { ...body?.params, pageSize: false },
      getHeaders(),
    ),
  add: (conf) => API.post('direction-filter/create', conf.data, getHeaders()),
  addSubFolder: (conf) =>
    API.post('direction-filter/create-subfolder', conf.data, getHeaders()),
  upd: (conf) =>
    API.put(`direction-filter/update/${conf.id}`, conf.data, getHeaders()),
  updSubfolder: (conf) =>
    API.put(`direction-filter/update-subfolder/${conf.id}`, conf, getHeaders()),
  remove: (conf, confirmation) =>
    API.delete(`direction-filter/delete/${conf.id}`, deletionConfirmationConfig(confirmation)).then(ensureApiSuccess),
  removeSubfolder: (id, confirmation) =>
    API.delete(`direction-filter/delete-subfolder/${id}`, deletionConfirmationConfig(confirmation)).then(ensureApiSuccess),
  view: (conf) => API.get(`direction-filter/view/${conf.id}`, getHeaders()),
  sorting: (conf) => API.post(`direction-filter/change-sorting`, conf.data),
  subfoldersSorting: (conf) =>
    API.post(`direction-filter/change-subfolders-sorting`, conf.data),
  getFolderContent: () => API.get(`direction-filter/folder-content`),
  saveFolderContent: (data) =>
    API.put(`direction-filter/update-folder-content`, data, getHeaders()),
}

export const directionAPI = {
  overview: (conf, signal) =>
    API.get(
      `direction/overview/${getParams(conf)}`,
      { signal: signal },
      getHeaders(),
    ),
  getAll: (conf, cancelToken) =>
    API.get(`direction/${getParams(conf)}`, {
      ...getHeaders(),
      cancelToken: cancelToken?.token,
    }),
  getCatalog: (conf) =>
    API.get(`direction/catalog${getParams(conf)}`, {}, getHeaders()),
  get: (conf) =>
    API.get(`direction/view/${conf.id}${getParams(conf)}`, getHeaders()),
  getTariff: (conf) =>
    API.get(`direction-tariff/view/${conf.id}`, getHeaders()),
  getHWbyMyCourse: (group_id, children_id) =>
    API.get(
      `direction-plan/group?group_id=${group_id}&children_id=${children_id}&expand=group.direction,group.coursePlans,group.materialPlans,group.lessonPlans.lesson.lessonTasks.task,group.teacher,group.lessonPlans.lesson.lessonVideos,group.lessonPlans.lesson.lessonMaterials,children.homeWork,group.materialPlans.children.homeWork`,
      {},
      getHeaders(),
    ),
  add: (conf) => API.post('direction/create', conf.data, getHeaders()),
  upd: (conf) =>
    API.post(`direction/update/${conf.id}`, conf.data, getHeaders()),
  remove: (conf, confirmation) => API.delete(`direction/delete/${conf.id}`, deletionConfirmationConfig(confirmation)).then(ensureApiSuccess),
  startDeletion: (id, confirmation) =>
    API.delete(`direction/delete-async/${id}`, deletionConfirmationConfig(confirmation)).then(ensureApiSuccess),
  deletionStatus: () => API.get('direction/deletion-status', getHeaders()).then(ensureApiSuccess),
  retryDeletion: (id, confirmation) =>
    API.post(`direction/retry-deletion/${id}`, { confirmation }, getHeaders()).then(ensureApiSuccess),
  cancelDeletion: (id, confirmation) =>
    API.post(`direction/cancel-deletion/${id}`, { confirmation }, getHeaders()).then(ensureApiSuccess),
  sorting: (conf) => API.post(`direction/change-sorting`, conf.data),
  saveOrder: (data) => API.post('direction/save-order', data, getHeaders()),
  getTeacherByDiraction: (conf) =>
    API.get(
      `direction/${getParams(conf)}&expand=directionSeminarians.seminarian`,
      {},
      getHeaders(),
    ),
  getTypes: () => API.get('/direction-tariff/types'),
  bulkUpdatePaymentAcquiring: (data) =>
    API.post('/direction-tariff/bulk-update-payment-acquiring', data, getHeaders()),
  getTemplateIcons: () => API.get('/direction/course-icon-templates', getHeaders()),
  addFavorite: (data) => API.post('/direction/add-favorite', data),
  toggleView: (data) => API.post('/direction/toggle-view', data),
  getDepartments: (id) =>
    API.get(`/direction/departments/${id}`, getHeaders()),
  updateDepartments: (id, data) =>
    API.post(`/direction/departments/${id}`, data, getHeaders()),
  createCopy: (data) => API.post('/direction/create-copy', data),
}

export const catalogApi = {
  getAll: (conf) =>
    API.get(`catalog${getParams(conf)}`, {}, getHeaders()),
}

export const betaDirectionAPI = {
  get: (conf) =>
    API.get(`direction/view/${conf.id}${getParams(conf)}`, getHeaders()),
  getTariff: (conf) =>
    API.get(`direction-tariff/view/${conf.id}`, getHeaders()),
  add: (conf) => API.post('direction/create', conf.data, getHeaders()),
  upd: (conf) =>
    API.post(`direction/update/${conf.id}`, conf.data, getHeaders()),
  getTypes: () => API.get('/direction-tariff/types'),
  bulkUpdatePaymentAcquiring: (data) =>
    API.post('/direction-tariff/bulk-update-payment-acquiring', data, getHeaders()),
  getTemplateIcons: () => API.get('/direction/course-icon-templates', getHeaders()),
  copy: (data) =>
    API.post(`/direction/copy-theme-to-course`, data, getHeaders()),
}

export const courseAPI = {
  getAll: (conf) =>
    API.get(`direction-course/${getParams(conf)}`, getHeaders()),
  add: (data) => API.post('direction-course/create', data, getHeaders()),
  upd: (conf) =>
    API.put(`direction-course/update/${conf.id}`, conf.data, getHeaders()),
  remove: (id, confirmation) => API.delete(`direction-course/delete/${id}`, deletionConfirmationConfig(confirmation)).then(ensureApiSuccess),
  view: (conf) => API.get(`direction-course/view/${conf.id}${getParams(conf)}`),
  sorting: (conf) => API.post(`direction-course/change-sorting`, conf.data),
  getSchedule: (groupId, courseId) =>
    API.get(
      `direction-course/get-schedule?groupId=${groupId}&courseId=${courseId}`,
    ),
  uploadCourse: (data) => API.post(`direction-course/upload`, data),
  getLearningDynamics: (studentId) =>
    API.get(`direction-course/learning-dynamics?id=${studentId}`, getHeaders()),
  getLearningDynamicsV2: (studentId) =>
    API.get(`direction-course/learning-dynamics-v2?id=${studentId}`, getHeaders()),
  setAccessLevel: (data) =>
    API.post('direction-course/set-access-level', data, getHeaders()),
  resetCourseLearningDynamic: (data) =>
    API.get(
      `direction-course/learning-dynamics-course-reset?userId=${data?.userId}&courseId=${data?.courseId}`,
    ),
  resetTopicLearningDynamic: (data) =>
    API.get(
      `direction-course/learning-dynamics-topic-reset?userId=${data?.userId}&courseId=${data?.courseId}&topicId=${data?.topicId}`,
    ),
  changeGrantForUser: (data) =>
    API.post('direction-course/set-grant', data, getHeaders()),
  changeBlockGrantForUser: (data) =>
    API.post('direction-course/set-block-grant', data, getHeaders()),
  resetBlockProgressForUser: (data) =>
    API.post(
      'direction-course/learning-dynamics-block-reset',
      data,
      getHeaders(),
    ),
  changeLessonUserProgress: (data) =>
    API.post('direction-course/set-user-progress', data, getHeaders()),

  getAdditionalSettings: (conf) =>
    API.get(`direction-course-settings${getParams(conf)}`, getHeaders()),
  addNewGroupName: (conf) =>
    API.post(
      `direction-course-settings/add-new-group-name`,
      conf.data,
      getHeaders(),
    ),
  deleteGroupName: (id) =>
    API.delete(
      `direction-course-settings/delete-group-mame/${id}`,
      getHeaders(),
    ),
  saveAdditionalSettings: (conf) =>
    API.post(
      `direction-course-settings/save-additional-settings`,
      conf.data,
      getHeaders(),
    ),
}

export const themeAPI = {
  getAll: (conf) => API.get(`task-topic/${getParams(conf)}`, getHeaders()),
  get: (id) => API.get(`task-topic/${id}`, getHeaders()),
  add: (conf) => API.post('task-topic/create', conf.data, getHeaders()),
  upd: (conf) =>
    API.put(`task-topic/update/${conf.id}`, conf.data, getHeaders()),
  deleteInfo: (id) => API.get(`task-topic/delete-info/${id}`, getHeaders()).then(ensureApiSuccess),
  remove: (id, confirmation) =>
    API.delete(`task-topic/delete/${id}`, deletionConfirmationConfig(confirmation)).then(ensureApiSuccess),
}

export const subThemeAPI = {
  getAll: (conf, cancelToken) =>
    API.get(`task-subtopic/${getParams(conf)}`, {
      ...getHeaders(),
      cancelToken: cancelToken?.token,
    }),
  get: (id) => API.get(`task-subtopic/${id}`, getHeaders()),
  add: (data) => API.post('task-subtopic/create', data, getHeaders()),
  upd: (conf) =>
    API.put(`task-subtopic/update/${conf.id}`, conf.data, getHeaders()),
  deleteInfo: (id) => API.get(`task-subtopic/delete-info/${id}`, getHeaders()).then(ensureApiSuccess),
  remove: (id, confirmation) =>
    API.delete(`task-subtopic/delete/${id}`, deletionConfirmationConfig(confirmation)).then(ensureApiSuccess),
}

export const subSubThemeAPI = {
  getAll: (conf, cancelToken) => {
    return API.get(`task-subsubtopic/${getParams(conf)}`, {
      ...getHeaders(),
      cancelToken: cancelToken?.token,
    })
  },
  get: (id) => API.get(`task-subsubtopic/${id}`, getHeaders()),
  add: (data) => API.post('task-subsubtopic/create', data, getHeaders()),
  upd: (conf) =>
    API.put(`task-subsubtopic/update/${conf.id}`, conf.data, getHeaders()),
  deleteInfo: (id) => API.get(`task-subsubtopic/delete-info/${id}`, getHeaders()).then(ensureApiSuccess),
  remove: (id, confirmation) =>
    API.delete(`task-subsubtopic/delete/${id}`, deletionConfirmationConfig(confirmation)).then(ensureApiSuccess),
}

export const examNumberAPI = {
  getAll: (conf) =>
    API.get(`task-exam-number/${getParams(conf)}`, getHeaders()),
  get: (id) => API.get(`task-exam-number/${id}`, getHeaders()),
  add: (conf) => API.post('task-exam-number/create', conf.data, getHeaders()),
  upd: (conf) =>
    API.put(`task-exam-number/update/${conf.id}`, conf.data, getHeaders()),
  remove: (id) => API.delete(`task-exam-number/delete/${id}`, getHeaders()),
}

export const homeTaskApi = {
  getTypes: () => API.get('home-task/task-types', getHeaders()),
  getAll: (conf) => API.get(`home-task/${getParams(conf)}`, getHeaders()),
  get: (id) =>
    API.get(`home-task/view/${id}?expand=homeTaskFiles`, getHeaders()),
  add: (conf) =>
    API.post(
      `home-task/create/${getParams(conf)}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  upd: (conf) =>
    API.put(
      `home-task/update/${conf.id}${getParams(conf)}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  remove: (id) => API.delete(`home-task/delete/${id}`, getHeaders()),
  removeFile: (id) =>
    API.delete(`home-task/delete-file-task/${id}`, getHeaders()),
}

export const courseMaterialApi = {
  getAll: (conf) => API.get(`course-material/${getParams(conf)}`, getHeaders()),
  add: (data) => API.post('course-material/create', data, getHeaders()),
  upd: (conf) =>
    API.put(`course-material/update/${conf.id}`, conf.data, getHeaders()),
  view: (conf) =>
    API.get(`course-material/view/${conf.id}${getParams(conf)}`, getHeaders()),
  remove: (id, confirmation) => API.delete(`course-material/delete/${id}`, deletionConfirmationConfig(confirmation)).then(ensureApiSuccess),
  updProbe: (conf) =>
    API.put(`course-material/update-probe/${conf.id}`, conf.data, getHeaders()),
  updControl: (conf) =>
    API.put(
      `course-material/update-control/${conf.id}`,
      conf.data,
      getHeaders(),
    ),
  updColloquium: (conf) =>
    API.put(
      `course-material/update-colloquium/${conf.id}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  updColloquiumGallery: (conf) =>
    API.put(
      `course-material/update-colloquium-gallery/${conf.id}`,
      conf.data,
      getHeaders(),
    ),
  removeColloquiumGallery: (id) =>
    API.delete(`course-material/delete-colloquium-gallery/${id}`, getHeaders()),

  sorting: (conf) => API.post(`course-material/change-sorting`, conf.data),
}

export const lessonThemeApi = {
  getAll: (conf) => API.get(`topic-lesson/${getParams(conf)}`, getHeaders()),
  add: (data) => API.post('topic-lesson/create', data, getHeaders()),
  upd: (conf, config = {}) =>
    API.put(`topic-lesson/update/${conf.id}`, conf.data, {
      ...config,
      headers: getHeaders().headers,
    }),
  view: (conf) =>
    API.get(`topic-lesson/view/${conf.id}${getParams(conf)}`, getHeaders()),
  remove: (id, confirmation) => API.delete(`topic-lesson/delete/${id}`, deletionConfirmationConfig(confirmation)).then(ensureApiSuccess),
  setRating: (body) =>
    API({ url: 'topic-lesson/set-video-rating', ...body, method: 'POST' }),
  getLessonData: (params) =>
    API.get(`topic-lesson/get-lesson-data`, { params }),
  getReactionsBlocks: (params) =>
    API.get('/topic-lesson/reactions-blocks', { params }),
  setRatingBlock: (body) =>
    API({ url: 'topic-lesson/set-rating-block', ...body, method: 'POST' }),
}

export const childrenAPI = {
  add: (data) => API.post('user/create-children', data, getHeaders()),
  generateCredentials: () => API.get('user/generate-student-credentials', getHeaders()),
}

export const additionalProbeApi = {
  getAll: (conf) =>
    API.get(`additional-probe${'/' + getParams(conf)}`, getHeaders()),
  add: (conf) =>
    API.post(
      `additional-probe/create/${getParams(conf)}`,
      conf.data,
      getHeaders(),
    ),
  upd: (conf) =>
    API.put(
      `additional-probe/update/${conf.id}${getParams(conf)}`,
      conf.data,
      getHeaders(),
    ),
  view: (conf) =>
    API.get(`additional-probe/view/${conf.id}${getParams(conf)}`, getHeaders()),
  remove: (conf) =>
    API.delete(`additional-probe/delete/${conf.id}`, getHeaders()),
}

//Groups
export const directionGroupApi = {
  get: (conf) => API.get(`direction-group${getParams(conf)}`, getHeaders()),
  getAllGroups: (conf) =>
    API.get(`direction-group/get-all-groups${getParams(conf)}`, getHeaders()),
  getByDirections: (params) =>
    API.get(`directions-group${getParams(params)}`, getHeaders()),
  update: (id, data) =>
    API.put(`direction-group/update/${id}`, data, getHeaders()),
  updateSettings: (id, data) =>
    API.put(`direction-group/update-settings/${id}`, data, getHeaders()),
  getList: (conf) =>
    API.get(`direction-group/get-list${getParams(conf)}`, getHeaders()),
  getWithPagination: (conf) =>
    API.get(`direction-group/get-with-pagination${getParams(conf)}`),
  add: (conf) =>
    API.post(
      `direction-group/create/${getParams(conf)}`,
      conf.data,
      getHeaders(),
    ),
  addStudents: (conf) =>
    API.post(`direction-group/distribute`, conf.data, getHeaders()),
  updGroup: (conf) =>
    API.post(
      `direction-group/change-group${getParams(conf)}`,
      conf.data,
      getHeaders(),
    ),
  updSeminarian: (conf) =>
    API.post(
      `direction-group/change-teacher${getParams(conf)}`,
      conf.data,
      getHeaders(),
    ),
  updGroupName: (conf) =>
    API.post(
      `direction-group/change-name-group${getParams(conf)}`,
      conf.data,
      getHeaders(),
    ),
  updGroupMaxStudents: (conf) =>
    API.post(`direction-group/change-max-students`, conf.data, getHeaders()),
  updTeacherSalary: (data) =>
    API.post(`direction-group/change-teacher-salary`, data, getHeaders()),
  updTeacherSalaryForAllGroups: (data) =>
    API.post(
      `direction-group/change-teacher-salary-all-groups`,
      data,
      getHeaders(),
    ),

  updGroupTeacher: (conf) =>
    API.put(
      `direction-group/update/${conf.id}`,
      { teacher_id: conf.teacher_id },
      getHeaders(),
    ),

  updAdditionalTeachers: (conf) =>
    API.put(
      `direction-group/update/${conf.id}`,
      { additional_teacher_ids: conf.additional_teacher_ids },
      getHeaders(),
    ),

  updGroupSupervisor: (conf) =>
    API.put(
      `direction-group/update-supervisor/${conf.id}`,
      { supervisor_ids: conf.supervisor_ids },
      getHeaders(),
    ),

  removeGroup: (conf, confirmation) =>
    API.post(`direction-group/delete-group/${conf.id.value}`, { confirmation }, { ...getHeaders(), skipGlobalErrorAlert: true }).then(ensureApiSuccess),
  // Массовое удаление: 202 — заявка принята, прогресс берётся из bulkDeleteStatus
  bulkDeleteGroups: (groupIds, password) =>
    API.post('direction-group/bulk-delete', { group_ids: groupIds, password }, { skipGlobalErrorAlert: true }).then(ensureApiSuccess),
  bulkDeleteStatus: (batchId) =>
    API.get('direction-group/bulk-delete-status', { params: { batch_id: batchId }, skipGlobalErrorAlert: true }).then(ensureApiSuccess),

  getStudentsBygroup: (params) =>
    API.get(`/direction-group/get-students`, { params }),

  removeStudentsFromGroup: (params) =>
    API.post(`direction-group/remove-students`, params),
  moveStudentsToGroup: (data) => API.put(`direction-group/move-students`, data),
  getDirectionGroupsWithStudents: (conf) =>
    API.get(`direction-group/with-students${getParams(conf)}`, getHeaders()),
  deleteCustomColumn: (data) =>
    API.post('/direction-group/delete-custom-column', data),
  updateCustomColumn: (data) =>
    API.post('/direction-group/update-custom-column', data),
}

export const directionOrdersApi = {
  getKtpGroupSelections: (childrenId) =>
    API.get(
      `direction-orders/ktp-group-selections?children_id=${childrenId}`,
      getHeaders(),
    ),
  updAdditionalTeachers: (conf) =>
    API.put(
      `direction-orders/update-additional-teachers/${conf.id}`,
      { additional_teacher_ids: conf.additional_teacher_ids },
      getHeaders(),
    ),
  checkDisabled: (body) =>
    API({ url: `direction-orders/check-disabled`, ...body, method: 'GET' }),

  changeDiscountForChild: (params) =>
    API.post('direction-orders/change-discount-for-child', params),
  changePriceForChild: (params) =>
    API.post('direction-orders/change-price-for-child', params),
  updatePaymentIdentifier: (params) =>
    API.post('direction-orders/update-payment-identifier', params),

  get: (conf) =>
    API.get(
      `direction-orders${getParams(conf)}${
        conf.notFree ? '&notFree=true' : ''
      }${conf.allRows ? '&allRows=true' : ''}`,
      getHeaders(),
    ),

  show: (id) => API.get(`direction-orders/show/${id}?expand=directionTariffs`),
  view: (conf) => API.get(`direction-orders/view?id=${conf.id}`),
  add: (conf) =>
    API.post(
      `direction-orders/create${getParams(conf)}`,
      conf.data,
      getHeaders(),
    ),
  remove: (conf, body = {}) =>
    API({
      url: `direction-orders/delete/${conf.id}`,
      ...body,
      method: 'DELETE',
    }),

  updComments: (conf) =>
    API.put(
      `direction-orders/update-comment?id=${conf.id}`,
      conf.data,
      getHeaders(),
    ),
  createOrder: (conf) =>
    API.post(
      `direction-orders/create-order${getParams(conf)}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  getMyOrders: (conf) =>
    API({ url: `direction-orders/get-student-directions${getParams(conf)}` }),
  usedDemoDirections: (childrenId) =>
    API.get(
      `direction-orders/used-demo-directions${
        childrenId ? `?children_id=${childrenId}` : ''
      }`,
      { skipGlobalErrorAlert: true },
    ),

  buy: (conf) =>
    API.post(`direction-orders/buy-direction${getParams(conf)}`, conf.data),
  enroll: (data) => API.post(`direction-orders/enroll-direction`, data),
  checkReferralCode: (data, config = {}) =>
    API.post(`direction-orders/check-referral-code`, data, config),
  payment: (conf) => API.post(`direction-orders/payment`, conf.data),
  extend: (body) =>
    API({ url: `direction-orders/extend`, ...body, method: 'POST' }),
  extendByManager: (body) =>
    API({ url: `direction-orders/extend-by-manager`, ...body, method: 'POST' }),
  extendClass: (body) =>
    API({ url: `direction-orders/extend-class`, ...body, method: 'POST' }),
  extendAll: (body) =>
    API({ url: `direction-orders/extend-all`, ...body, method: 'POST' }),
  extendClassByManager: (body) =>
    API({
      url: `direction-orders/extend-class-by-manager`,
      ...body,
      method: 'POST',
    }),
  activePromoCode: (conf) =>
    API.post(
      `direction-orders/active-promo-code`,
      conf.data,
      {
        params: {
          code: conf.promo_code,
          tariff_id: conf.tariff_id,
          amount: conf.amount,
        },
      },
    ),

  groupLessonPriceDates: (id) =>
    API.get('direction-orders/group-lesson-price-dates', { params: { id } }),

  updPrivateInfo: ({ data, params }) =>
    API({
      url: `direction-orders/update-private-info`,
      data,
      params,
      method: 'PUT',
    }),

  index: (body) =>
    API({ url: `direction-orders/index`, ...body, method: 'GET' }),
  dataFilled: (body) =>
    API({ url: `direction-orders/data-filled`, ...body, method: 'PUT' }),
  sendToBot: (body) =>
    API({ url: `direction-orders/send-to-bot`, ...body, method: 'PUT' }),
  parentTouch: (body) =>
    API({ url: `direction-orders/parent-touch`, ...body, method: 'PUT' }),

  managerPayments: (body) =>
    API({ url: `direction-orders/manager-payments`, ...body, method: 'GET' }),
  orderDisable: (body) =>
    API({ url: `direction-orders/order-disable`, ...body, method: 'PUT' }),
  postpone: (body) =>
    API({ url: `direction-orders/postpone`, ...body, method: 'POST' }),
  postponeCancel: (body) =>
    API({ url: `direction-orders/postpone-cancel`, ...body, method: 'POST' }),

  getPrivateOwners: (
    teacher_id,
    direction_id,
    hide_unpaid = 0,
    future_only = 0,
  ) =>
    API.get(
      `direction-orders/private-students-by-seminarian?teacher_id=${teacher_id}&direction_id=${direction_id}&hide_unpaid=${hide_unpaid}&future_only=${future_only}`,
    ),

  addComment: (data) => API.post('direction-orders/add-comment', data),

  getHistoty: (conf) =>
    API({
      url: `direction-orders/get-payment-history${getParams(conf)}`,
      method: 'GET',
    }),
  getHistory: (conf) =>
    API.get(`direction-orders/get-payment-history-v2${getParams(conf)}`),
  getHistoryExcel: (conf) =>
    API.get(`direction-orders/payment-history-v2-excel${getParams(conf)}`, {
      responseType: 'blob',
    }),
  getHistoryForSelect: (conf) =>
    API.get(`direction-orders/history-for-select${getParams(conf)}`),
  getStudentsWithPagination: (params) =>
    API.get(
      `direction-orders/get-students-with-pagination/${getParams(params)}`,
    ),
}

export const purposePaymentApi = {
  list: (userId) => API.get(`purpose-payment/index?user_id=${userId}`),
  create: (data) => API.post('purpose-payment/create', data),
  update: (id, data) => API.put(`purpose-payment/update?id=${id}`, data),
  remove: (id) => API.delete(`purpose-payment/delete?id=${id}`),
  markPaid: (id) => API.post(`purpose-payment/mark-paid?id=${id}`),
  settings: () => API.get('purpose-payment/settings'),
  publicView: (paymentId) =>
    API.get(`purpose-payment/public-view?payment_id=${encodeURIComponent(paymentId)}`),
  pay: (data) => API.post('purpose-payment/pay', data),
}

export const fitnessOneCApi = {
  settings: () => API.get('fitness-one-c/settings'),
  saveSettings: (data) => API.put('fitness-one-c/save-settings', data),
  check: () => API.post('fitness-one-c/check'),
  debts: () => API.get('fitness-one-c/debts'),
  pay: (data) => API.post('fitness-one-c/pay', data),
}

export const integrationLogApi = {
  list: (params = {}) => API.get(`integration-log/index${getParams(params)}`),
}

const unwrapReferralResponse = (response) => ({
  ...response,
  data: response.data?.data ?? response.data,
})

export const referralProgramApi = {
  getTariffs: () =>
    API.get('referral-program/tariffs').then(unwrapReferralResponse),
  updateTariffs: (tariffIds) =>
    API.put('referral-program/tariffs', { tariff_ids: tariffIds }).then(
      unwrapReferralResponse,
    ),
  getBalance: (userId) =>
    API.get('referral-program/balance', {
      params: userId ? { user_id: userId } : {},
    }).then(unwrapReferralResponse),
  getHistory: (params = {}) =>
    API.get('referral-program/history', { params }).then(unwrapReferralResponse),
  getReport: (params = {}) =>
    API.get('referral-program/report', { params }).then(unwrapReferralResponse),
  exportReport: (params = {}) =>
    API.get('referral-program/export', { params, responseType: 'blob' }),
  adjustBalance: (data) =>
    API.post('referral-program/adjust-balance', data)
      .then(ensureApiSuccess)
      .then(unwrapReferralResponse),
  getRules: () =>
    API.get('referral-program/rules').then(ensureApiSuccess).then(unwrapReferralResponse),
  updateRules: (rules) =>
    API.put('referral-program/rules', { rules }).then(ensureApiSuccess).then(unwrapReferralResponse),
  getExternalProducts: () =>
    API.get('referral-program/external-products').then(ensureApiSuccess).then(unwrapReferralResponse),
  updateExternalProducts: (products, commentTemplate = '') =>
    API.put('referral-program/external-products', {
      products,
      comment_template: commentTemplate,
    }).then(ensureApiSuccess).then(unwrapReferralResponse),
  getExternalProductsTemplate: () =>
    API.get('referral-program/external-products-template', { responseType: 'blob' }),
  importExternalProducts: (file) => {
    const data = new FormData()
    data.append('file', file)
    return API.post('referral-program/external-products-import', data, getHeaders(['FormData']))
      .then(ensureApiSuccess)
      .then(unwrapReferralResponse)
  },
}

export const childrenGroupApi = {
  getGroups: (conf) =>
    API.get(
      `direction-plan/group?group_id=${conf.id}&children_id=${conf.children}&noEmptyMaterialPlans=true&expand=group.direction,group.coursePlans.order.tariff,group.materialPlans,group.lessonPlans.lesson.lessonTasks.task,group.teacher,group.lessonPlans.lesson.lessonVideos,group.lessonPlans.lesson.lessonMaterials`,
    ),
  getIndividual: (conf) =>
    API.get(
      `direction-plan/private?directionId=${conf.id}&noEmptyMaterialPlans=true&expand=coursePlans,materialPlans,lessonPlans.lesson.lessonTasks.task,order.direction,order.teacher,lessonPlans.lesson.lessonVideos`,
  ),
}

export const blockAccessConfigApi = {
  getConfigs: (params) =>
    API.get(`block-access-config/index${getParams(params)}`),
  getConfig: (params) =>
    API.get(`block-access-config/view${getParams(params)}`, {
      skipGlobalErrorAlert: true,
    }),
  getAvailableGroups: (params) =>
    API.get(`block-access-config/available-groups${getParams(params)}`),
  saveConfig: (data) =>
    API.post('block-access-config/save', data, { skipGlobalErrorAlert: true }),
  deleteConfig: (data) =>
    API.post('block-access-config/delete', data, { skipGlobalErrorAlert: true }),
}

export const beta = {
  saveOrderBlocks: (params) => API.post(`lesson-blocks/save-order`, params),
  deleteBlock: (id) => API.delete(`lesson-blocks/delete?id=${id}`),

  addBlockInLesson: (data) =>
    API.post('lesson-blocks/create', data, getHeaders()),
  saveBlockInLesson: (data) =>
    API.post('lesson-blocks/update', data, getHeaders()),
  updThemeData: (conf) =>
    API.put(`direction-plan-beta/update-theme`, conf.data, getHeaders()),

  remove: (id, confirmation) => API.delete(`direction-plan-beta/delete-theme?id=${id}`, deletionConfirmationConfig(confirmation)).then(ensureApiSuccess),

  getMyCoursesBeta: (conf) =>
    API.get(`direction-orders-beta/my-courses${getParams(conf)}`, getHeaders()),
  getUserCourses: (data) =>
    API.get(`direction-orders-beta/view-user-courses${getParams(data)}`),
  getUserProfile: (data) =>
    API.get(`direction-orders-beta/view-profile${getParams(data)}`),
  getLessonsInTheTopic: (conf) =>
    API.get(
      `direction-plan-beta/get-theme-lessons${getParams(conf)}`,
      getHeaders(),
    ),
  getCourseBlocks: (conf) =>
    API.get(
      `direction-plan-beta/get-course-blocks/${getParams(conf)}`,
      getHeaders(),
    ),
  getCourseBlocksCancel: (conf) => {
    if (cancelToken.getCourseBlocks) {
      cancelToken.getCourseBlocks.cancel(
        'Previous request canceled due to new request.',
      )
    }

    cancelToken.getCourseBlocks = axios.CancelToken.source()

    return API.get(`direction-plan-beta/get-course-blocks/${getParams(conf)}`, {
      headers: getHeaders().headers,
      cancelToken: cancelToken.getCourseBlocks.token,
    })
  },

  getLessonData: (conf) =>
    API.get(`direction-plan-beta/view-lesson/${getParams(conf)}`, getHeaders()),

  getScheduleBeta: (conf) =>
    API.get(`direction-plan-beta/get-block-themes${getParams(conf)}`),

  addTopic: (data) =>
    API.post('direction-plan-beta/create-theme', data, getHeaders()),
  addProbe: (data) =>
    API.post('direction-plan-beta/create-probe', data, getHeaders()),
  addControl: (data) =>
    API.post('direction-plan-beta/create-control', data, getHeaders()),
  addColloquium: (data) =>
    API.post('direction-plan-beta/create-colloquium', data, getHeaders()),
  getBlockThemes: (conf) =>
    API.get(
      `direction-plan-beta/get-block-themes/${getParams(conf)}`,
      getHeaders(),
    ),
  changeThemesSorting: (conf) =>
    API.post(`direction-plan-beta/change-themes-sorting/`, conf.data),
  sorting: (conf) =>
    API.post(`direction-plan-beta/change-lesson-sorting`, conf.data),

  getCertificatePercentages: (params) =>
    API.get(`direction-plan-beta/certificate-percentages/${getParams(params)}`),
  getLessonReport: (params) =>
    API.get(`direction-plan-beta/get-lesson-report/${getParams(params)}`),
  getCoursesForSeniorSeminarian: (params) =>
    API.get(
      `direction-plan-beta/get-courses-for-senior-seminarian/${getParams(
        params,
      )}`,
    ),
  getLessonBlock: ({ id }) =>
    API.get(`direction-plan-beta/view-block?id=${id}`),
}

export const aiCourseStructureApi = {
  generate: (data) =>
    API.post('ai-generator/generate-course-structure', data).then(
      ensureApiSuccess,
    ),
}

export const aiLessonContentApi = {
  generate: (data) =>
    API.post('ai-generator/generate-lesson-content', data).then(
      ensureApiSuccess,
    ),
}

export const homeWorkApi = {
  get: (conf, cancelToken) =>
    API.get(`home-work${getParams(conf)}`, {
      ...getHeaders(),
      cancelToken: cancelToken?.token,
    }),
  view: (conf) => API.get(`home-work/view/${conf.id}${getParams(conf)}`),
  aiTutorDialog: (conf) =>
    API.get(`home-work/ai-tutor-dialog${getParams(conf)}`, getHeaders()),
  sendAnswer: (conf) =>
    API.post(
      `home-work/send-answer/${conf.id}${getParams(conf)}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  runCode: (data) => API.post('home-work/run-code', data, getHeaders()),
  getCodeAiStatus: (conf) =>
    API.get(`code-ai/status${getParams(conf)}`, getHeaders()),
  returnForFixes: (id, data) =>
    API.post(
      `home-work/return-for-fixes/${id}`,
      data,
      getHeaders(['FormData']),
    ),
  add: (conf) => API.post(`home-work/set-home-work`, conf.data),
  addMass: (conf) => API.post(`home-work/set-home-work-mass`, conf.data),
  addLink: (conf) => API.post(`home-work/type-link`, conf.data),
  pass: (conf) => API.post(`home-work/pass-work?id=${conf.id}`, conf.data),
  saveProgress: (conf) =>
    API.post(`home-work/save-progress?id=${conf.id}`, conf.data),
  evaluation: (conf) =>
    API.post(`home-work/work-evaluation?id=${conf.id}`, conf.data),
  getOwnWorks: (conf, cancelToken) =>
    API({
      url: `home-work/get-own-works/${getParams(conf)}`,
      cancelToken: cancelToken?.token,
      method: 'GET',
    }),
  getOwnWorksForRedax: (conf) => {
    return API({
      url: `home-work/get-own-works/${getParams(conf)}`,
      method: 'GET',
    })
  },

  getAllWorks: (conf, cancelToken) =>
    API.get(`home-work/get-all-works/${getParams(conf)}`, {
      ...getHeaders(),
      cancelToken: cancelToken?.token,
    }),
  getHomeworkPageAllWorks: (query = '', cancelToken) =>
    API.get(`homework-page/all-works${query ? `?${query}` : ''}`, {
      ...getHeaders(),
      cancelToken: cancelToken?.token,
    }),
  getHomeworkPageStatusCounters: (query = '', cancelToken) =>
    API.get(`homework-page/status-counters${query ? `?${query}` : ''}`, {
      ...getHeaders(),
      cancelToken: cancelToken?.token,
    }),
  getHomeworkPageArchiveYears: (query = '', cancelToken) =>
    API.get(`homework-page/archive-years${query ? `?${query}` : ''}`, {
      ...getHeaders(),
      cancelToken: cancelToken?.token,
    }),
  deleteHomeworkPageWorks: (works, confirmation) =>
    API.post('homework-page/delete-works', { works, confirmation }),
  restoreHomeworkPageWorks: (works) =>
    API.post('homework-page/restore-works', { works }),
  // Разовая автопроверка сданных ДЗ: ids - id домашних работ (не больше 100 за запрос)
  autoCheckHomeworkPageWorks: (ids) =>
    API.post('homework-page/auto-check-works', { ids }),
  // Массовое удаление по фильтрам списка: параметры те же, что и у all-works
  deleteHomeworkPageWorksByFilter: (query = '', confirmation) =>
    API.post(
      `homework-page/delete-works-by-filter${query ? `?${query}` : ''}`,
      { confirmation },
    ),
  addCommentFile: (conf) =>
    API.post(
      `home-work/add-comment-files`,
      conf.data,
      getHeaders(['FormData']),
    ),
  addWorkCommentFiles: (conf) =>
    API.post(
      `home-work/add-work-comment-files`,
      conf.data,
      getHeaders(['FormData']),
    ),
  removeWorkCommentFile: (conf) =>
    API.delete(
      `home-work/delete-work-comment-file?work_id=${conf.work_id}&file_index=${conf.index}`,
    ),
  removeCommentFile: (conf) =>
    API.delete(
      `home-work/delete-comment-file?work_id=${conf.work_id}&task_id=${conf.task_id}&file_index=${conf.index}`,
    ),
  timeout: (conf) =>
    API.post(`home-work/work-evaluation?id=${conf.id}&timeout=true`, conf.data),
  setUnique: (conf) => API.post(`home-work/set-unique-home-work`, conf.data),
  setUniqueMass: (conf) =>
    API.post(`home-work/set-unique-home-work-mass`, conf.data),
  generateUniqueWorkLink: () => API.get(`home-work/generate-unique-work-link`),
  getUniqueWorks: (params) =>
    API.get(`home-work/unique-works${getParams(params ?? {})}`),
  getUniqueWork: (id) => API.get(`home-work/unique-work?id=${id}`),
  cancelScheduledUniqueWork: (id) =>
    API.post(`home-work/cancel-scheduled-unique-work`, { id }),
  remove: (conf) => API.delete(`home-work/canceled-work?id=${conf.id}`),
  backToWorkApi: (conf) => API.post(`home-work/back-to-work?id=${conf.id}`),
  archive: (id, type) => API.post(`home-work/archive?id=${id}&type=${type}`),
  unarchive: (id, type, deadline) =>
    API.post(`home-work/unarchive${getParams({ id, type, deadline })}`),
  changeDeadline: (id, deadline) =>
    API.post(`home-work/change-deadline?id=${id}&deadline=${deadline}`),
  edit: (conf) => API.post(`home-work/edit?id=${conf.id}`, conf.data),
  startTimer: (data) => API.post(`home-work/start-timer`, data),
  getTimer: (task_id, work_id) =>
    API.get(`home-work/get-timer?task_id=${task_id}&work_id=${work_id}`),
  trackWorkExecutionTime: (conf) =>
    API.post(`home-work/track-work-execution-time?id=${conf.id}`, conf.data),
  start: (conf) => API.post(`home-work/start-work?id=${conf.id}`),
  pause: (conf) => API.post(`home-work/stop-work?id=${conf.id}`),
  prepareLink: (conf) => API.get(`home-work/prepare-link${getParams(conf)}`),
}

export const probeApi = {
  get: (conf) =>
    API.get(
      conf.id
        ? `probe/${getParams(conf)}&planId=${conf.id}`
        : `probe/${getParams(conf)}`,
    ),
  view: (conf) => API.get(`probe/view${getParams(conf)}&id=${conf.id}`),
  start: (conf) => API.post(`probe/start-probe?id=${conf.id}`),
  pause: (conf) => API.post(`probe/stop-probe?id=${conf.id}`),
  trackWorkExecutionTime: (conf) =>
    API.post(`probe/track-work-execution-time?id=${conf.id}`, conf.data),
  pass: (conf) =>
    API.post(
      `probe/pass-work?workId=${conf.id}`,
      conf.data,
      getHeaders(['FormData']),
    ),

  getOwnWorks: (conf, cancelToken) =>
    API({
      url: `probe/get-own-works/${getParams(conf)}`,
      cancelToken: cancelToken?.token,
      method: 'GET',
    }),
  // getOwnWorks: (conf) => API.get(`probe/get-own-works${getParams(conf)}`),
  evaluation: (conf) =>
    API.post(`probe/work-evaluation?id=${conf.id}`, conf.data),
  getMy: (conf, cancelToken) =>
    API.get(`probe/get-my-probes${getParams(conf)}`, {
      ...getHeaders(),
      cancelToken: cancelToken?.token,
    }),
  addCommentFile: (conf) =>
    API.post(`probe/add-comment-files`, conf.data, getHeaders(['FormData'])),
  addWorkCommentFiles: (conf) =>
    API.post(
      `probe/add-work-comment-files`,
      conf.data,
      getHeaders(['FormData']),
    ),
  removeWorkCommentFile: (conf) =>
    API.delete(
      `probe/delete-work-comment-file?work_id=${conf.work_id}&file_index=${conf.index}`,
    ),
  removeCommentFile: (conf) =>
    API.delete(
      `probe/delete-comment-file?work_id=${conf.work_id}&task_id=${conf.task_id}&file_index=${conf.index}`,
    ),
  timeout: (conf) =>
    API.post(`probe/work-evaluation?id=${conf.id}&timeout=true`, conf.data),
  remove: (conf) => API.delete(`probe/delete?id=${conf.id}`),
  backToWorkApi: (conf) => API.post(`probe/back-to-work?id=${conf.id}`),
  edit: (conf) => API.post(`probe/edit?id=${conf.id}`, conf.data),
  editNumberOfTasksInPartC: (data) => API.post(`/probe/generate-c-tasks`, data),

  sendAnswer: (conf) =>
    API.post(
      `probe/send-answer?id=${conf.id}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  // Фоновое автосохранение: ошибки не показываем, компонент повторит попытку сам
  saveDraftAnswers: (conf) =>
    API.post(
      `probe/save-draft-answers/${getParams(conf)}`,
      conf.data,
      { skipGlobalErrorAlert: true },
    ),
  getDraftAnswers: (conf) =>
    API.get(`probe/get-draft-answers${getParams(conf)}`, {
      skipGlobalErrorAlert: true,
    }),
  changeDeadline: (id, deadline) =>
    API.post(`probe/change-deadline?id=${id}&deadline=${deadline}`),
}

export const controlApi = {
  // get: (conf) => API.get(`control-work${getParams(conf)}`),
  get: (conf, cancelToken) =>
    API({
      url: `control-work/${getParams(conf)}`,
      cancelToken: cancelToken?.token,
      method: 'GET',
    }),
  view: (conf) => API.get(`control-work/view${getParams(conf)}&id=${conf.id}`),
  start: (conf) => API.post(`/control-work/start-work?id=${conf.id}`),
  pause: (conf) => API.post(`control-work/stop-work?id=${conf.id}`),
  sendAnswer: (conf) =>
    API.post(
      `control-work/send-answer?id=${conf.id}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  pass: (conf) => API.post(`control-work/pass-work?id=${conf.id}`),
  trackWorkExecutionTime: (conf) =>
    API.post(`control-work/track-work-execution-time?id=${conf.id}`, conf.data),
  evaluation: (conf) =>
    API.post(`control-work/work-evaluation?id=${conf.id}`, conf.data),

  addCommentFile: (conf) =>
    API.post(
      `control-work/add-comment-files`,
      conf.data,
      getHeaders(['FormData']),
    ),
  addWorkCommentFiles: (conf) =>
    API.post(
      `control-work/add-work-comment-files`,
      conf.data,
      getHeaders(['FormData']),
    ),
  removeWorkCommentFile: (conf) =>
    API.delete(
      `control-work/delete-work-comment-file?work_id=${conf.work_id}&file_index=${conf.index}`,
    ),
  removeCommentFile: (conf) =>
    API.delete(
      `control-work/delete-comment-file?work_id=${conf.work_id}&task_id=${conf.task_id}&file_index=${conf.index}`,
    ),

  timeout: (conf) =>
    API.post(
      `control-work/work-evaluation?id=${conf.id}&timeout=true`,
      conf.data,
    ),
  remove: (conf) => API.delete(`control-work/delete?id=${conf.id}`),
  backToWorkApi: (conf) => API.post(`control-work/back-to-work?id=${conf.id}`),
  edit: (conf) => API.post(`control-work/edit?id=${conf.id}`, conf.data),
  changeDeadline: (id, deadline) =>
    API.post(`control-work/change-deadline?id=${id}&deadline=${deadline}`),
}

export const recordingLessonAPI = {
  getAll: (conf) => API.get(`lesson-record${getParams(conf)}`),
  add: (conf) => API.post(`lesson-record/create`, conf.data),
  upd: (conf) =>
    API.put(`lesson-record/update/${conf.id}${getParams(conf)}`, conf.data),
  view: (conf) => API.get(`lesson-record/view/${conf.id}${getParams(conf)}`),
  remove: (conf) => API.delete(`lesson-record/delete?id=${conf.id}`),
}

export const timetableAPI = {
  getFamiliarLessonIds: (_) => API.get(`timetable/get-familiar-lesson-ids`),
  get: ({ params }) => API({ url: `timetable`, params, method: 'GET' }),
  getChildrenAll: ({ params }) =>
    API({ url: `timetable/children-all`, params, method: 'GET' }),
  getChildren: ({ params }) =>
    API({ url: `timetable/children-own`, params, method: 'GET' }),
  show: (id, date = null) => API.get(`timetable/show?id=${id}&date=${date}`),
  add: (conf) =>
    API.post(`timetable/create?conference=${conf.type}`, conf.data),
  done: (conf) => API.post(`timetable/done?id=${conf.id}`, conf.data),
  changeDiscount: (conf) =>
    API.post(
      `timetable/change-discount?id=${conf.id}&date=${conf.date}`,
      conf.data,
    ),
  reschedule: (conf) =>
    API.post(`timetable/reschedule?id=${conf.id}`, conf.data),
  changeSpeaker: (conf) =>
    API.post(`timetable/change-speaker?id=${conf.id}`, conf.data),
  conference: (params) =>
    API({
      url: `timetable/conference-without-status/${getParams(params)}`,
      method: 'GET',
    }),
  cancel: (conf) => API.post(`timetable/cancel?id=${conf.id}`, conf.data),

  cancelReport: (body) =>
    API({ url: `timetable/cancel-report`, ...body, method: 'POST' }),

  massReport: (data) =>
    API({ url: `timetable/mass-report`, data, method: 'POST' }),

  pupilsClass: (conf) =>
    API.post(`timetable/pupils-class?id=${conf.id}`, conf.data),

  seminariansСlasses: (conf) =>
    API.post(`timetable/seminarians-classes?id=${conf.id}`, conf.data),

  selectTopic: (conf) =>
    API.post(`timetable/select-topic?id=${conf.id}`, conf.data),

  recordingViaSchedule: (data) =>
    API.post(`timetable/enroll-via-schedule`, data),

  cancelRecording: (data) => API.post(`timetable/cancel-enrollment`, data),

  updateStatusComment: (data) =>
    API.post(`timetable-report/update-status-comment`, data),

  updateSalary: (data) => API.post(`timetable-report/update-salary`, data),

  updateDuration: (data) => API.post(`timetable-report/update-duration`, data),

  updateCourse: (data) => API.post(`timetable-report/update-course`, data),

  rescheduleIntroductory: (data) =>
    API.post(`timetable-report/reschedule-introductory`, data),

  saveTimeOpeningLessonFirstTime: (data) =>
    API.post(`timetable-report/record-entry-time`, data),

  getAdditionalActivities: (params) =>
    API({
      url: `timetable-beta/get-additional-activities/${getParams(params)}`,
      method: 'GET',
    }),
  studentsLessonStatuses: (id) =>
    API.get(`timetable/students-lesson-statuses?id=${id}`),
  updateStudentsLessonStatuses: (data) =>
    API.post(`timetable/update-students-lesson-statuses`, data, getHeaders()),
}

export const lessonAbstractAPI = {
  get: (conf, cancelToken) =>
    API.get(`lesson-abstract${getParams(conf)}`, {
      ...getHeaders(),
      cancelToken: cancelToken?.token,
    }),
  add: (conf) =>
    API.post(`lesson-abstract/create`, conf.data, getHeaders(['FormData'])),
  evaluation: (conf) =>
    API.post(`lesson-abstract/evaluation?id=${conf.id}`, conf.data),
  backToWorkApi: (conf) =>
    API.post(`lesson-abstract/back-to-work?id=${conf.id}`),
  existAbstract: (conf) =>
    API.get(`lesson-abstract/exist-abstract?plan_id=${conf.id}`),
}

export const journalBetaApi = {
  getJournal: (params) =>
    API.get(`journal-beta/general-journal${getParams(params)}`),
  getJournalPrivate: (params) =>
    API.get(`journal-beta/general-journal-private${getParams(params)}`),
  getAdditionalFields: (params) =>
    API.get(`journal-beta/get-additional-fields${getParams(params)}`),
  getAdditionalFieldsList: () =>
    API.get(`journal-beta/get-additional-fields-list`),
  editAdditionalField: (params) =>
    API.put('journal-beta/edit-additional-field', params),
  deleteAdditionalField: (id) =>
    API.delete(`journal-beta/delete-additional-field/${id}`),
  getStudentJournal: (params) =>
    API.get(`journal-beta/general-student-journal${getParams(params)}`),
  getWorkAndProbe: (params) =>
    API.get(`journal-beta/work-and-probe${getParams(params)}`),
  getStudentWorkAndProbe: (params) =>
    API.get(`journal-beta/student-work-and-probe${getParams(params)}`),
  getPrivateWorkAndProbe: (params) =>
    API.get(`journal-beta/private-work-and-probe${getParams(params)}`),
  editGrades: (params) => API.put('journal-beta/edit-grades', params),
  addColumn: (params) => API.put('journal-beta/add-column', params),
  pinColumn: (params) => API.put('journal-beta/pin-column', params),
  deleteColumn: (id) => API.delete(`/journal-beta/delete-column/${id}`),
  addField: (params) => API.put('journal-beta/add-field', params),
  getStudentReportsByDirection: (params) =>
    API.get(`journal-beta/student-reports-by-direction${getParams(params)}`),
  getMyDirectionsAndSubstitutions: (user_id) =>
    API.get(`journal-beta/my-directions-and-substitutions?user_id=${user_id}`),
  getFieldsAnalytics: (params) =>
    API.get(`journal-beta/fields-analytics${getParams(params)}`),
  getChildrenAnalytics: (params) =>
    API.get(`journal-beta/children-analytics${getParams(params)}`),
  getKTPAnalytics: (params) =>
    API.get(`journal-beta/ktp-analytics${getParams(params)}`),
  allKTP: (params) => API.get(`ktp-journal/multi${getParams(params)}`),
  getTestAnalyticsTableSettings: () =>
    API.get(`ktp-journal/test-analytics-table-settings`),
  setTestAnalyticsTableSettings: (params) =>
    API.put(`ktp-journal/test-analytics-table-settings-save`, params),
  getTestAnalytics: (childId) =>
    API.get(`ktp-journal/test-analytics-table-settings?child_id=${childId}`),
  addColumnFinalAnalytics: (params) =>
    API.post('journal-beta/add-column-final-analytics', params),
  updateColumnFinalAnalytics: (params) =>
    API.post('journal-beta/update-column-final-analytics', params),
  deleteColumnFinalAnalytics: (id) =>
    API.delete(`/journal-beta/delete-column-final-analytics/${id}`),
  getFinalAnalytics: (params) =>
    API.get(`journal-beta/final-analytics${getParams(params)}`),
  getFieldsFinalAnalytics: () =>
    API.get(`journal-beta/get-fields-final-analytics`),
  getSettingsDownloadExcel: () =>
    API.get(`journal-beta/get-settings-download-exel`),
  updateSettingsDownloadExcel: (params) =>
    API.post(`journal-beta/save-settings-download-exel`, params),
  getSpecificStudentExportDirections: (params) =>
    API.get(`journal-beta/specific-student-export-directions${getParams(params)}`),
  getButtonsGradesPopup: () =>
    API.get(`journal-beta/save-buttons-grades-popup`),
  getButtonsGradesPopupCourse: (directionId) =>
    API.get(`journal-beta/buttons-grades-popup-course?direction_id=${directionId}`),
  saveButtonsGradesPopupCourse: (params) =>
    API.post('journal-beta/buttons-grades-popup-course', params),
  saveButtonsGradesPopup: (params) =>
    API.post(`journal-beta/save-buttons-grades-popup`, params),
  getChildAttendanceStatus: () =>
    API.get(`journal-beta/get-child-attendance-status`),
  saveChildAttendanceStatus: (params) =>
    API.post(`journal-beta/save-child-attendance-status`, params),
  getLessonTypes: () =>
    API.get(`journal-beta/get-lesson-types`),
  saveLessonTypes: (params) =>
    API.post(`journal-beta/save-lesson-types`, params),
  setLessonTypes: params =>
    API.get(`journal-beta/set-lesson-types${getParams(params)}`),
  getTabAccessSettings: () => API.post('journal-beta/tab-access-settings'),
  getAvailableTabs: (params) =>
    API.get(`journal-beta/tab-access-settings${getParams(params)}`),
  updateTabAccessSettings: (tabKey, data) =>
    API.post('journal-beta/tab-access-settings', { tab_key: tabKey, ...data }).then(ensureApiSuccess),
  getTabOrder: () => API.get('journal-beta/tab-order'),
  saveTabOrder: (tabs) => API.post('journal-beta/tab-order', { tabs }).then(ensureApiSuccess),
}

export const presenceFoodJournalApi = {
  getSettings: () => API.get('presence-food-journal/settings'),
  saveRules: (rules) => API.post('presence-food-journal/save-rules', { rules }),
  saveExtraColumns: (columns) =>
    API.post('presence-food-journal/save-extra-columns', { columns }),
  getJournal: (params) =>
    API({ url: 'presence-food-journal/journal', params, method: 'GET' }),
  setStatus: (data) => API.put('presence-food-journal/set-status', data),
  updateColumn: (id, data) =>
    API.patch(`presence-food-journal/update-column/${id}`, data),
  deleteColumn: (id) =>
    API.delete(`presence-food-journal/delete-column/${id}`),
  setExtraValue: (data) =>
    API.put('presence-food-journal/set-extra-value', data),
}
export const journalApi = {
  getHomeWork: ({ params }) =>
    API({ url: `student-journal/home-works`, params, method: 'GET' }),

  getProbe: ({ params }) =>
    API({ url: `student-journal/probe-works`, params, method: 'GET' }),

  getControlWork: ({ params }) =>
    API({ url: `student-journal/control-works`, params, method: 'GET' }),

  getAttendance: ({ params }) =>
    API({ url: `student-journal/attendance`, params, method: 'GET' }),
  addAttendance: (conf) =>
    API.post(`student-journal/add-attendance`, conf.data),
  editGrades: (conf) => API.put('student-journal/edit-grades', conf.data),
  periodCreate: (data) => API.post(`/journal-periods/create-period`, data),
  periodUpdate: (id, data) => API.put(`/journal-periods/update/${id}`, data),
  periodGet: (params) => API.get(`/journal-periods/list`, { params }),
  periodDelete: (id) => API.delete(`/journal-periods/delete/${id}`),
  updateButtons: (data) => API.put('student-journal/update-buttons', data),
  getButtons: () => API.put('student-journal/buttons'),
  periodGrage: (id) =>
    API.delete(`/student-journal/delete-grade?gradeId=${id}`),

  getColumnsSettings: () => API.get(`student-journal/get-columns`),
  getAdditionalColumnsSettings: () => API.get(`student-journal/get-additional-columns`),
  addColumnsSettings: (data) => API.post(`student-journal/add-columns`, data).then(ensureApiSuccess),
  fillAdditional: (data) => API.post(`student-journal/fill-additional`, data),
  fillAdditionalColumn: (data) => API.post(`student-journal/fill-additional-column`, data),
  getAdditional: ({ params }) =>
    API({ url: `/student-journal/show-additional`, params, method: 'GET' }),
  getAdditionalByClass: ({ params }) =>
    API({
      url: `/student-journal/show-additional-by-class`,
      params,
      method: 'GET',
    }),
  getAdditionalColumnsByClass: ({ params }) =>
    API({
      url: `/student-journal/show-additional-columns-by-class`,
      params,
      method: 'GET',
    }),

  getWithReplacement: (id) =>
    API.get(`direction-group/with-replacement?id=${id}`),

  getKPT: (params) =>
    API({ url: `ktp-journal/${getParams(params)}`, method: 'GET' }),
  getCourseKPTBlocks: ({ params }) =>
    API({ url: `ktp-journal/course-blocks`, params, method: 'GET' }),
  updateKTP: (data) => API.put('ktp-journal/update', data),
  reorderKTP: (data) => API.post('ktp-journal/reorder', data),
  resetKTPOrder: (data) => API.post('ktp-journal/reset-order', data),
  fillKTPScheduleDates: (data) =>
    API.post('ktp-journal/fill-schedule-dates', data),
  updateKTPLessonsAccess: (groupId) =>
    API.get(`ktp-journal/update-access?group_id=${groupId}`),
  removeKTP: (id, disabled) =>
    API.delete(`ktp-journal/delete?id=${id}&disabled=${disabled}`),
  removeAllKTP: (groupId) =>
    API.delete(`ktp-journal/delete-all?group_id=${groupId}`),
  downloadKPT: (id, params) =>
    API.get(`ktp-journal/export?group=${id}`, params),
  downloadKPTdraft: (params) =>
    API.get(`ktp-journal/download-template`, params),
  uploadKTP: (body, config) =>
    API.post(`ktp-journal/upload`, body, {
      ...config,
      headers: getHeaders(['FormData']),
    }),
}

export const seminarPresentationAPI = {
  get: (conf) => API.get(`seminar-presentation${getParams(conf)}`),
  getType: (body) => API.get(`seminar-presentation/get-seminar-types`),
  add: (conf) => API.post(`seminar-presentation/create`, conf.data),
  upd: (conf) =>
    API.put(`seminar-presentation/update?id=${conf.id}`, conf.data),
  remove: (conf) => API.delete(`seminar-presentation/delete?id=${conf.id}`),
}

export const reportAPI = {
  getDisabledOrders: (conf) =>
    API.get(`reports/disabled-orders${getParams(conf)}`, getHeaders()),
  getSales: (conf) => API.get(`reports/sales${getParams(conf)}`, getHeaders()),
  updateDisabledOrder: (body) =>
    API.post(`reports/update-disabled-order`, body),

  customForParents: {
    reports: ({ params, ...conf }) => API.get(`reports/custom-for-parents-reports/${getParams(conf)}`, getHeaders()),
    settings: ({ params, ...conf }) => API.get(`reports/custom-for-parents/${getParams(conf)}`, getHeaders()),
    save: (body) => API.post(`reports/custom-for-parents-save`, body),
    remove: (body) => API.post(`reports/custom-for-parents-remove`, body),
    updatePreview: (body, config) => API.post(`reports/custom-for-parents-preview-update`, body, config),
    sendReport: (body, config) => API.post(`reports/custom-for-parents-send`, body, config),
    massPreviewAction: (body, config) => API.post(`reports/custom-for-parents-mass-action`, body, config),
    generateAi: (body) => API.post(`reports/custom-for-parents-generate-ai`, body),
    massGenerateAi: (body) => API.post(`reports/custom-for-parents-mass-generate-ai`, body),
    testGenerateAi: (body) => API.post(`reports/custom-for-parents-test-generate-ai`, body),
  },

  certificates: {
    get: ({ params, ...conf }) =>
      API.get(`reports/certificates/${getParams(conf)}`, getHeaders()),
  },

  aiTutor: {
    tutors: ({ params, ...conf } = {}) =>
      API.get(`ai-tutor-report/tutors${getParams({ ...conf, ...(params ?? {}) })}`, getHeaders()),
    sessions: ({ params, ...conf } = {}) =>
      API.get(`ai-tutor-report/sessions${getParams({ ...conf, ...(params ?? {}) })}`, getHeaders()),
    answers: ({ params, ...conf } = {}) =>
      API.get(`ai-tutor-report/answers${getParams({ ...conf, ...(params ?? {}) })}`, getHeaders()),
    answerView: ({ id }) =>
      API.get(`ai-tutor-report/answer-view${getParams({ id })}`, getHeaders()),
    sessionView: ({ id }) =>
      API.get(`ai-tutor-report/session-view${getParams({ id })}`, getHeaders()),
  },

  reportForParents: {
    get: (body) =>
      API({ url: `reports/report-for-parents`, ...body, method: 'GET' }),
    add: (body) =>
      API({ url: `reports/create-report-parent`, ...body, method: 'POST' }),
    transferred: (conf) =>
      API.post(`reports/transferred-report-parent?id=${conf.id}`),
    getChildren: ({ params }) =>
      API({ url: `reports/child-for-parent-report`, params, method: 'GET' }),
  },

  private: {
    week: ({ params }) =>
      API({ url: `reports/private-week`, params, method: 'GET' }),
    seminarian: ({ params }) =>
      API({ url: `reports/private-seminarian`, params, method: 'GET' }),
    seminarianToExcel: ({ params }) =>
      API({
        url: `reports/private-seminarian-to-excel`,
        params,
        method: 'GET',
      }),
    students: ({ params, ...conf }) =>
      API.get(`reports/private-students${getParams(conf)}`, getHeaders()),
    studentsUnassignedCount: () =>
      API.get(`reports/private-students-unassigned-count`, getHeaders()),
    updateTeacher: (data) =>
      API.post(`reports/private-students-update-teacher`, data),
    updateLessonDuration: (data) =>
      API.post(`reports/private-students-update-lesson-duration`, data),
    updateSalary: (data) =>
      API.post(`reports/private-students-update-salary`, data),
    updateCostForStudent: (data) =>
      API.post(`reports/private-students-update-cost-for-student`, data),
    updateStudent: (data) => API.post(`reports/private-students-update`, data),
    byStudents: ({ params, ...conf }) =>
      API.get(`reports/private-by-students/${getParams(conf)}`, getHeaders()),
    bySeminarians: ({ params, ...conf }) =>
      API.get(
        `reports/private-by-seminarians/${getParams(conf)}`,
        getHeaders(),
      ),
    allLessons: ({ params, ...conf }) =>
      API.get(`reports/private-all-lessons/${getParams(conf)}`, getHeaders()),
    weekly: ({ params, ...conf }) =>
      API.get(`reports/private-weekly/${getParams(conf)}`, getHeaders()),
    updateScheduled: (data) =>
      API.post(`reports/private-weekly-update-scheduled`, data, getHeaders()),
  },

  introductory: {
    allLessons: ({ params, ...conf }) =>
      API.get(
        `reports/introductory-all-lessons/${getParams(conf)}`,
        getHeaders(),
      ),
    analytics: ({ params, ...conf }) =>
      API.get(
        `reports/introductory-analytics/${getParams(conf)}`,
        getHeaders(),
      ),
    updateCrmStatus: (data) =>
      API.post(`reports/introductory-update-crm-status`, data, {
        ...getHeaders(),
        skipGlobalErrorAlert: true,
      }),
  },

  lectureAnalytics: ({ params }) =>
    API({ url: `reports/lecture-analytics`, params, method: 'GET' }),

  group: {
    group: (body) => API({ url: `reports/groups`, ...body, method: 'GET' }),
    wrapper: ({ params }) =>
      API({ url: 'reports/group-reports', params, method: 'GET' }),
    overview: ({ params }) => {
      if (cancelToken.groupOverview)
        cancelToken.groupOverview.cancel(
          'Previous request canceled due to new request.',
        )
      cancelToken.groupOverview = axios.CancelToken.source()

      return API({
        url: `reports/groups-overview`,
        params,
        cancelToken: cancelToken.groupOverview.token,
        method: 'GET',
      })
    },

    seminarian: ({ params }) => {
      if (cancelToken.groupSeminarian)
        cancelToken.groupSeminarian.cancel(
          'Previous request canceled due to new request.',
        )
      cancelToken.groupSeminarian = axios.CancelToken.source()

      return API({
        url: `reports/group-seminarian`,
        params,
        cancelToken: cancelToken.groupSeminarian.token,
        method: 'GET',
      })
    },

    byGroups: ({ params, ...conf }) =>
      API.get(`reports/by-groups/${getParams(conf)}`, getHeaders()),
    bySeminarians: ({ params, ...conf }) =>
      API.get(`reports/by-seminarians/${getParams(conf)}`, getHeaders()),
    allLessons: ({ params, ...conf }) =>
      API.get(`reports/group-all-lessons/${getParams(conf)}`, getHeaders()),
  },

  groupLessonPayment: {
    byGroups: ({ params, ...conf }) =>
      API.get(
        `reports/group-lesson-payment-by-groups/${getParams(conf)}`,
        getHeaders(),
      ),
    byLessons: ({ params, ...conf }) =>
      API.get(
        `reports/group-lesson-payment-by-lessons/${getParams(conf)}`,
        getHeaders(),
      ),
    seminarianSalary: ({ params, ...conf }) =>
      API.get(
        `reports/group-lesson-payment-seminarian-salary/${getParams(conf)}`,
        getHeaders(),
      ),
    lessonIncomeDetails: (id) =>
      API.get(
        `reports/group-lesson-payment-lesson-income-details?id=${id}`,
        getHeaders(),
      ),
    studentsLessonStatuses: (id) =>
      API.get(`timetable/students-lesson-statuses?id=${id}`),
    updateStudentsLessonStatuses: (data) =>
      API.post(
        `reports/group-lesson-payment-update-students-lesson-statuses`,
        data,
        getHeaders(),
      ),
  },

  lessonReportsSeminarian: ({ params, ...conf }) =>
    API.get(
      `reports/lesson-reports-by-seminarian/${getParams(conf)}`,
      getHeaders(),
    ),

  payments: {
    payments: (body) => API({ url: `reports/payments`, ...body }),
    paymentsv2: ({ params, ...conf }) =>
      API.get(`reports/paymentsv2/${getParams(conf)}`, getHeaders()),
    paymentsRemove: (id) => API.get(`polymorph-payment/remove/${id}`),
    updateAmount: (body) => API.post(`polymorph-payment/update-amount`, body),
    updateComment: (body) => API.post(`reports/payment-update-comment`, body),
  },

  homework: {
    general: ({ params, ...conf }) =>
      API.get(`report-home-work/general/${getParams(conf)}`, getHeaders()),
    lesson: ({ params, ...conf }) =>
      API.get(`report-home-work/lesson/${getParams(conf)}`, getHeaders()),
    lessonByUsers: ({ params, ...conf }) =>
      API.get(
        `report-home-work/lesson-by-users/${getParams(conf)}`,
        getHeaders(),
      ),
    exercise: ({ params, ...conf }) =>
      API.get(`report-home-work/exercise/${getParams(conf)}`, getHeaders()),
    getExerciseRespondents: ({ params, ...conf }) =>
      API.get(
        `report-home-work/exercise-respondents/${getParams(conf)}`,
        getHeaders(),
      ),
    statistics: ({ params, ...conf }) =>
      API.get(`report-home-work/statistics/${getParams(conf)}`, getHeaders()),
    studentsStatistics: ({ params, ...conf }) =>
      API.get(
        `report-home-work/students-statistics/${getParams(conf)}`,
        getHeaders(),
      ),
    studentUncomplited: (studentId) =>
      API.get(
        `report-home-work/students-uncomplited/${studentId}`,
        getHeaders(),
      ),
    groupPlan: ({ params, ...conf }) =>
      API.get(`report-home-work/group-plan/${getParams(conf)}`, getHeaders()),
  },

  totalSalary: ({ params, ...conf }) =>
    API.get(`reports/total-salary/${getParams(conf)}`, getHeaders()),
  totalSalarySaveEmployeeSalary: (data) =>
    API.post('reports/total-salary-save-employee-salary', data, getHeaders()),
  totalSalarySaveAssignmentRates: (data) =>
    API.post('reports/total-salary-save-assignment-rates', data, getHeaders()),
  totalSalaryDeleteAssignmentRates: (data) =>
    API.post('reports/total-salary-delete-assignment-rates', data, getHeaders()),
  totalSalaryReorderAssignmentRates: (data) =>
    API.post('reports/total-salary-reorder-assignment-rates', data, getHeaders()),
  totalSalarySavePaymentPlan: (data) =>
    API.post('reports/total-salary-save-payment-plan', data, getHeaders()),
  totalSalarySavePaymentFact: (data) =>
    API.post('reports/total-salary-save-payment-fact', data, getHeaders()),
  totalSalaryDeletePaymentFact: (data) =>
    API.post('reports/total-salary-delete-payment-fact', data, getHeaders()),
  totalSalarySaveKpiSettings: (data) =>
    API.post('reports/total-salary-save-kpi-settings', data, getHeaders()),
  totalSalarySaveKpiStatus: (data) =>
    API.post('reports/total-salary-save-kpi-status', data, getHeaders()),
  totalSalarySaveEmployeeKpiRows: (data) =>
    API.post('reports/total-salary-save-employee-kpi-rows', data, getHeaders()),
  totalSalaryExport: (params) =>
    API.get(`reports/total-salary-export${getParams(params)}`, {
      ...getHeaders(),
      responseType: 'blob',
    }),

  ownBacklog: (body) => API({ url: 'reports/own-backlog', ...body }),

  sop: {
    get: (body) => API({ url: 'reports/sop-questions', ...body }),
    send: (body) => API({ url: 'reports/sop-send', ...body, method: 'POST' }),
  },

  platformVisits: (params) =>
    API({ url: `reports/platform-visits`, params, method: 'GET' }),

  platformVisitsUpdate: () =>
    API({ url: '/reports/platform-visits-refresh', method: 'POST' }),

  activityAnalytics: (params) =>
    API({ url: 'reports/activity-analytics', params, method: 'GET' }),

  activeStudentLessonDynamics: (params) =>
    API({ url: 'reports/active-student-lesson-dynamics', params, method: 'GET' }),

  ipLog: ({ params, ...conf }) =>
    API.get(`reports/ip-log/${getParams(conf)}`, getHeaders()),
  ipLogStatus: () => API.get('reports/ip-log-status', getHeaders()),
  ipLogEnable: () => API.post('reports/ip-log-enable', {}, getHeaders()),
  ipLogBackups: () => API.get('reports/ip-log-backups', getHeaders()),
  ipControlToggle: (data) =>
    API.post('reports/ip-control-toggle', data, getHeaders()),
  supportTickets: ({ params, ...conf }) =>
    API.get(`reports/support-tickets/${getParams(conf)}`, getHeaders()),

  contractReport: ({ paramsPagination, ...conf } = {}) =>
    API.get(
      `reports/contract-report${getParams({
        ...conf,
        page: paramsPagination?.page,
        pageSize: paramsPagination?.perPage,
      })}`,
      getHeaders(),
    ).then((res) => {
      const payload = res?.data?.data ?? res?.data ?? {}

      return {
        ...res,
        data: {
          data: payload.items ?? [],
          meta: payload.meta ?? payload._meta ?? {},
          filters: payload.filters ?? {},
        },
      }
    }),

  contractReportUpdate: ({ id, data }) =>
    API.put(`reports/contract-report-update?id=${id}`, data, getHeaders()),

  contractReportToggleProcessed: ({ id }) =>
    API.post(
      `reports/contract-report-toggle-processed?id=${id}`,
      {},
      getHeaders(),
    ),

  contractReportSendForSignature: ({ id, data }) =>
    API.post(
      `reports/contract-report-send-for-signature?id=${id}`,
      data,
      { ...getHeaders(), skipGlobalErrorAlert: true },
    ),

  contractReportDelete: ({ id }) =>
    API.delete(`reports/contract-report-delete?id=${id}`, getHeaders()),

  contractReportHistory: ({ id }) =>
    API.get(`reports/contract-report-history?id=${id}`, getHeaders()).then(
      (res) => {
        const payload = res?.data?.data ?? res?.data ?? {}
        return {
          ...res,
          data: payload.history ?? payload ?? [],
        }
      },
    ),

  getDebtorPaymentReport: (params) =>
    API({ url: `reports/list-debtors/${getParams(params)}`, method: 'GET' }),
  updateDebtorPaymentComment: (body) =>
    API.post('reports/debtor-update-comment', body),
  updateExtendDebtor: (body) => API.post('reports/extend-debtor', body),
  getAdditionalActivitiesReport: (params) =>
    API.get(
      `reports/get-additional-activities/${getParams(params)}`,
      getHeaders(),
    ),
  updateAdditionalActivitySalary: (data) =>
    API.post('reports/additional-activities-update-salary', data, getHeaders()),
  addAdditionalActivityStudent: (data) =>
    API.post('reports/additional-activities-add-student', data, getHeaders()),

  chats: {
    students: ({ params, ...conf }) =>
      API.get(`reports/students-chats/${getParams(conf)}`, getHeaders()),
    employees: ({ params, ...conf }) =>
      API.get(`reports/employees-chats/${getParams(conf)}`, getHeaders()),
    generateChatStatistics: (data) =>
      API.post(`reports/chats-generate`, data, getHeaders()),
    chatsByPeriod: ({ conf }) =>
      API.get(`reports/student-chat-list${getParams(conf)}`, getHeaders()),
    chatMessagesByPeriod: ({ conf }) =>
      API.get(`reports/student-chat-messages${getParams(conf)}`, getHeaders()),
  },
}

export const userRating = {
  get: (conf) =>
    API.get(`user/rating${getParams(conf)}`, getHeaders()),
  updateRating: (body) => API.post(`user/rating-update`, body),
  getChangeNotifications: () =>
    API.get('user/rating-change-notifications', getHeaders()),
  confirmChangeNotifications: (body) =>
    API.post('user/rating-change-notifications-read', body, getHeaders()),
  getPointsHistory: () => API.get('user/points-history', getHeaders()),
  downloadPointsHistory: () =>
    API.get('user/points-history-excel', {
      ...getHeaders(),
      responseType: 'blob',
    }),
}

export const promoCodeAPI = {
  get: (body) => API({ url: `promo-code`, ...body }),
  add: (conf) => API.post(`promo-code/create`, conf.data),
  remove: (conf) => API.delete(`promo-code/delete?id=${conf.id}`),
  check: (name, user, config = {}) =>
    API.post(`promo-code/check?name=${name}`, user, config),
}

export const supportAPI = {
  get: (body) => API({ url: `support/index`, ...body }),
  getTypes: (body) => API({ url: `support/get-support-types`, ...body }),
  add: (body) =>
    API({
      url: `support/create`,
      ...body,
      method: 'POST',
      headers: { 'Content-type': 'multipart/form-data' },
    }),
  done: (body) => API({ url: `support/done`, ...body, method: 'POST' }),
  accepted: (body) => API({ url: `support/accepted`, ...body, method: 'POST' }),
  cancel: (body) => API({ url: `support/cancel`, ...body, method: 'POST' }),
  remove: (body) => API({ url: `support/delete`, ...body, method: 'DELETE' }),
  unreadCount: () => API.get('support/unread-count'),
  read: (supportId) => API.post('support/read', { supportId }),
  getManualPaymentsOrders: (body) =>
    API.get(`support/get-manual-payments`, { ...body }),
  changeStatusManualPayment: (id, status) =>
    API.get(`support/set-manual-payment-status/${id}`, { params: { status } }),
}

export const bannerApi = {
  index: (body) => API({ url: `banner/index`, ...body, method: 'GET' }),
  show: (id) => API.get(`banner/show?id=${id}`),
  create: (data) =>
    API.post(`banner/create`, data, {
      headers: { 'Content-type': 'multipart/form-data' },
    }),
  update: (data) =>
    API.post(`banner/update`, data, {
      headers: { 'Content-type': 'multipart/form-data' },
    }),
  remove: (id) => API.post(`banner/delete?id=${id}`),
  copy: (data) => API.post(`banner/copy`, data),
  sort: (data) => API.post(`banner/sort`, data),
}

export const giftShopAPI = {
  getItems: (params) =>
    API.get(`gift-shop/index${getParams(params)}`, getHeaders()),
  create: (data) =>
    API.post('gift-shop/create', data, getHeaders(['FormData'])),
  update: (id, data) =>
    API.post(`gift-shop/update?id=${id}`, data, getHeaders(['FormData'])),
  remove: (id) => API.post(`gift-shop/delete?id=${id}`),
  buy: (data) => API.post('gift-shop/buy', data),
  getPurchases: (params) =>
    API.get(`gift-shop/purchases${getParams(params)}`, getHeaders()),
  getPromocodes: (params) =>
    API.get(`gift-shop/promocodes${getParams(params)}`, getHeaders()),
  updatePurchaseStatus: (id, data) =>
    API.post(`gift-shop/update-purchase-status?id=${id}`, data),
  deletePurchase: (id) => API.post(`gift-shop/delete-purchase?id=${id}`),
  getPendingCount: (params) =>
    API.get(`gift-shop/pending-count${getParams(params)}`, getHeaders()),
}

export const excelAPI = {
  getExcelTable: (body) => API({ url: 'user/export', ...body, method: 'GET' }),
}

export const communicationApi = {
  index: (params) => API.get('communication', { params }),
  update: (id, params) => API.put(`communication/update/${id}`, params),
  count: () => API.get('communication/count'),
}

export const settingApi = {
  getAll: (config) => API.get('setting/get-all', config),
  ensureReports: () => API.get('setting/ensure-reports'),
  update: (params) => API.put('setting/update-setting', params).then(ensureApiSuccess),
  getExternalHomeworkEnvironments: () =>
    API.get('setting/get-external-homework-environments'),
  saveExternalHomeworkEnvironments: (data) =>
    API.post('setting/save-external-homework-environments', data),
  uploadLogo: (data) => API.post('setting/upload-logo', data),
  uploadFavicon: (data) => API.post('setting/upload-favicon', data),
  uploadImageLoginPage: (data, config) =>
    API.post('setting/update-auth-image', data, config),
  uploadBackgroundImageLoginPage: (data, config) =>
    API.post('setting/update-auth-background-image', data, config),
  uploadCatalogLogo: (data) => API.post('setting/update-catalog-image', data),
  uploadImagePayByRequisites: (data) =>
    API.post('setting/update-pay-by-requisites-image', data),
  switchHundredSystem: (data) =>
    API.post('setting/switch-hundred-point-system', data),
  setChangeSystemParams: (data) =>
    API.post('setting/set-change-system-params', data),
  getNotificationSettings: () => API.get('setting/get-notification-settings'),
  saveNotificationContent: (data) =>
    API.post('setting/save-notification-content', data),
  getNotificationTypes: () => API.get('setting/get-notification-types'),
  updateNotificationTypeEnabled: (data) =>
    API.post('setting/update-notification-type', data),
  uploadCourseCatalogHeaderIcon: (data) =>
    API.post('setting/update-catalog-image', data),
  generateExternalAPIKeys: () => API.get('setting/regenerate-api-creds'),
  updateCssForHtmlBlocks: (data) =>
    API.post('setting/update-css-for-html-blocks', data),
  getCssForHtmlBlocks: () => API.get('setting/get-css-for-html-blocks'),
  getCurrentTime: () => API.get('setting/get-current-time'),
}


export const platformApi = {
  getStatus: () => API.get('common/platform-status'),
}
export const franchiseApi = {
  getAll: () => API.get('franchise'),
  getOptions: () => API.get('franchise/options'),
  getCourseTree: () => API.get('franchise/course-tree'),
  setEnabled: (enabled) => API.put('franchise/set-enabled', { enabled }),
  create: (data) => API.post('franchise/create', data),
  update: (id, data) => API.put(`franchise/update?id=${id}`, data),
  delete: (id, confirmation) =>
    API.delete(`franchise/delete?id=${id}`, deletionConfirmationConfig(confirmation)).then(ensureApiSuccess),
}

export const profileFieldsApi = {
  index: (params) => API.get('profile-fields/index', { params }),
  create: (data) => API.post('profile-fields/create', data),
  update: (id, data) => API.patch(`profile-fields/update?id=${id}`, data),
  delete: (id) => API.delete(`profile-fields/delete?id=${id}`),
  values: (params) => API.get('profile-fields/values', { params }),
  saveValues: ({ user_id, entity_type, custom_fields }) =>
    API.patch(
      `profile-fields/save-values?user_id=${user_id}&entity_type=${entity_type}`,
      { custom_fields },
    ),
}

export const notificationApi = {
  getNotifications: () => API.get(`notification/get-notifications`),
  markAsRead: () => API.put('notification/mark-as-read'),
  getUserNotificationSettings: (userId) =>
    API.get(`notification/get-user-notification-settings?user_id=${userId}`),
  updateUserNotificationChannel: (data) =>
    API.post('notification/update-user-notification-channel', data),
  updateUserParentNotification: (data) =>
    API.post('notification/update-user-parent-notification', data),
}

export const notificationByTriggerApi = {
  getAllNotifications: () => API.get(`trigger-notification`),
  getNotification: (id) => API.get(`trigger-notification/view?id=${id}`),
  deleteNotification: (id) =>
    API.delete(`trigger-notification/delete?id=${id}`),
  updateNotificationOrder: (data) =>
    API.post(`trigger-notification/update-order`, data),
  createNotification: (data) => API.post(`trigger-notification/create`, data),
  updateNotification: (id, data) =>
    API.put(`trigger-notification/update?id=${id}`, data),
  sendNotification: (data) => API.post(`trigger-notification/send`, data),
}

export const menuApi = {
  getMenu: (language, menuType, childId = null) =>
    API.get(
      `menu/get-active-menu?language=${language}&menuType=${menuType}&childId=${childId}`,
    ),
  getByRoleName: (roleName, language, menuType) =>
    API.get(
      `menu/get-menu?roleName=${roleName}&language=${language}&menuType=${menuType}`,
    ),
  getUserOrder: () => API.get('menu/get-user-order'),
  saveUserOrder: (items) => API.put('menu/save-user-order', { items }),
  changeActive: (id, roleName, menuType, language) =>
    API.put(
      `menu/change-active?id=${id}&roleName=${roleName}&menuType=${menuType}&language=${language}`,
    ),
  changeMenuItemName: (id, name, language, menuType, roleName) =>
    API.put(
      `menu/change-menu-item-name?id=${id}&name=${name}&language=${language}&menuType=${menuType}&roleName=${roleName}`,
    ),
  changeAvailableForUnits: (id, unitIds, menuType, roleName) =>
    API.put(
      `menu/change-available-for-units?id=${id}&menuType=${menuType}&roleName=${roleName}`,
      { unitIds },
    ),
  changeRank: (id, roleName, isUp, menuType) =>
    API.put(
      `menu/change-rank?id=${id}&roleName=${roleName}&isUp=${isUp}&menuType=${menuType}`,
    ),
  saveNewMenuItem: (data) => API.post('menu/create-menu-item', data),
  updateMenuItemUrl: (id, url) =>
    API.put(`menu/update-menu-url?id=${id}&url=${url}`),
  deleteMenuItem: (id) => API.delete(`menu/delete-menu-item/${id}`),
  createFolder: (data) => API.post('menu/create-folder', data),
  deleteFolder: (id) => API.delete(`menu/delete-folder/${id}`),
  renameFolder: (id, data) => API.put(`menu/rename-folder/${id}`, data),
  changeFolderRank: (id, roleName, isUp, menuType = 'basic') =>
    API.put(
      `menu/change-folder-rank?id=${id}&roleName=${roleName}&isUp=${isUp}&menuType=${menuType}`,
    ),
  moveItem: (id, role) =>
    API.put(`menu/move-item?itemId=${id}${role ? `&role=${role}` : ''}`),
  moveItemToFolder: (itemId, folderId, role) =>
    API.put(
      `menu/move-item?itemId=${itemId}&folderId=${folderId}&role=${role}`,
    ),
}

export const menuReportApi = {
  getMenu: (roleName) =>
    API.get(`menu-report/get-active-menu?roleName=${roleName}`),
  getByRoleName: (roleName, language) =>
    API.get(`menu-report/get-menu?roleName=${roleName}&language=${language}`),
  changeActive: (id, roleName, language) =>
    API.put(
      `menu-report/change-active?id=${id}&roleName=${roleName}&language=${language}`,
    ),
  changeFamily: (url, familyId) =>
    API.put('menu-report/change-family', {
      url,
      family_id: familyId,
    }),
  changeMenuItemName: (id, name, language) =>
    API.put(
      `menu-report/change-menu-item-name?id=${id}&name=${name}&language=${language}`,
    ),
  changeRank: (id, roleName, isUp) =>
    API.put(
      `menu-report/change-rank?id=${id}&roleName=${roleName}&isUp=${isUp}`,
    ),
}

export const publicUrl = [
  'setting/get-all',
  'survey/create-report',
  'survey/take-survey',
  'survey/get-pass',
  'survey/get-finish-window',
  'direction-filter',
  'direction-filter/get-subfolders',
  'banner/index',
  'direction',
  'direction/view',
  'promo-code',
  'user/check-email',
  'direction-orders/enroll-direction',
  'auth/restore-password',
  'auth/university2035-config',
  'user/signup',
  'home-work/prepare-link',
  'common/return-image',
  'common/platform-status',
  'crm-lead-payment-link/get-link',
  'classes/show',
  'classes/enroll-class',
  'direction-orders/extend-class',
  'classes/show-for-payment',
  'direction-orders-beta/view-profile',
  'direction-orders-beta/view-user-courses',
  'referral-program/balance',
  'user/get-balance-of-additional-activities',
  'polymorph-payment/additional-balance-acquiring-options',
  'polymorph-payment/additional-balance-deposit-v2',
  'library/shared',
]

export const exactPublicUrl = [
  'catalog',
  'user',
  'direction-orders',
  'direction-orders/extends',
]

export const faqApi = {
  get: (params) => API.get(`faq/get`, { params }),
  create: (params) => API.post('faq/create', params),
  update: (id, params) => API.put(`faq/update/${id}`, params),
  delete: (id) => API.delete(`faq/delete/${id}`),
}

export const adminPasswordsApi = {
  getStatus: () => API.get('admin-passwords/deletion-password-status').then(ensureApiSuccess),
  save: (data) => API.put('admin-passwords/deletion-password', data).then(ensureApiSuccess),
}
export const reactionsToTheVideo = {
  get: (params) => API.get('/topic-lesson/own-lesson-video-rating', { params }),
}

export const seminarianUncheckedHomework = {
  get: (params) =>
    API.get('/reports/seminarian-unchecked-homework-count', { params }),
}

export const fcmApi = {
  storeToken: (token) => API.post('fcm-messaging/store-token', { token }),
  removeToken: (token) => API.post('fcm-messaging/remove-token', { token }),
}

// Пути в стиле экшенов, чтобы хватало общих правил urlManager `v1/<controller>/<action>[/<id>]`
// и не требовалось править config/web.php на стендах.
export const helpdeskAPI = {
  getSettings: () => API.get('helpdesk/settings'),
  saveSettings: (data) => API.put('helpdesk/settings', data),
  getSystemStatuses: () => API.get('helpdesk/system-statuses'),
  getTickets: (params, cancelToken) =>
    API.get('helpdesk/tickets', { params, cancelToken: cancelToken?.token }),
  getAnalytics: (type, params) => API.get(`helpdesk/analytics/${type}`, { params }),
  exportAnalytics: (type, params) =>
    API.get(`helpdesk/analytics/${type}/export`, { params, responseType: 'blob' }),
  getTicket: (id, cancelToken) =>
    API.get(`helpdesk/ticket/${id}`, { cancelToken: cancelToken?.token }),
  updateTicket: (id, data) => API.patch(`helpdesk/update-ticket/${id}`, data),
  pauseTicket: (id) => API.post(`helpdesk/pause/${id}`),
  resumeTicket: (id) => API.post(`helpdesk/resume/${id}`),
  getManagerStatuses: () => API.get('helpdesk/managers/statuses'),
  pauseManager: (employeeId) =>
    API.post(`helpdesk/managers/${employeeId}/pause`),
  resumeManager: (employeeId) =>
    API.post(`helpdesk/managers/${employeeId}/resume`),
  closeTicket: (id) => API.post(`helpdesk/close/${id}`),
  rateTicket: (id, data) => API.post(`helpdesk/rating/${id}`, data),
  addNote: (id, text) => API.post(`helpdesk/notes/${id}`, { text }),
  addAssignee: (id, data) => API.post(`helpdesk/add-assignee/${id}`, data),
  removeAssignee: (id, userId, lineId) =>
    API.delete(`helpdesk/delete-assignee/${id}`, {
      params: { userId, line_id: lineId },
    }),
}

export const chatApi = {
  getUsersChatsList: (params, cancelToken) =>
    API.get(`chat/get-users-chat-name-list`, {
      params,
      cancelToken: cancelToken?.token,
    }),
  // getUserList: (params) => API.get(`get-users-chat-name-list`, {params}),
  createChat: (params) => API.post(`chat/create-chat`, params),
  // Существующий личный чат с пользователем без создания: { id } или { id: null }
  findDirectChat: (params) => API.get(`chat/direct-chat`, { params }),
  createSupportChat: (params) => API.post(`chat/create-support-chat`, params),
  getChatList: (params, cancelToken) =>
    API.get(`chat/chat-list/${getParams(params)}`, {
      cancelToken: cancelToken?.token,
    }),
  getChatListV2: (params, cancelToken) =>
    API.get(`chat/chat-list-v2/${getParams(params)}`, {
      cancelToken: cancelToken?.token,
    }),
  getChatListByIds: (params) => API.post(`chat/chat-list-by-ids`, params),
  // С lesson_id — чаты урока; без него — глобальный постраничный каталог.
  getLessonChats: (params = {}, cancelToken) =>
    API.get('chat/lesson-chats', {
      params,
      cancelToken: cancelToken?.token,
    }),
  getChat: (id, params = {}, cancelToken) =>
    API.get(`chat/chat-messages/${id}`, {
      params,
      cancelToken: cancelToken?.token,
    }),
  getActiveUsers: () => API.get(`chat/get-active-users`),
  getChatTopics: (chatId) =>
    API.get(`chat/topic-list`, { params: { chat_id: chatId } }),
  saveChatTopic: (params) => API.post(`chat/save-topic`, params),
  deleteChatTopic: ({ id, chat_id }) =>
    API.delete(`chat/delete-topic`, { params: { id, chat_id } }),
  updateMessage: (id, message) =>
    API.post(`chat/update-message/${id}`, { message }, { skipGlobalErrorAlert: true }).then(ensureApiSuccess),
  createMessage: (params, config) =>
    API.post(`chat/create-message`, params, config),
  scheduleMessage: (params, config) =>
    API.post(`chat/schedule-message`, params, config),
  getScheduledMessages: (params) =>
    API.get(`chat/get-scheduled-messages${getParams(params)}`),
  deleteScheduledMessages: (params) =>
    API.post(`chat/delete-schedule-message`, params),
  addMember: (params) => API.post(`chat/add-member`, params),
  deleteMember: (id) => API.delete(`chat/remove-member/${id}`),
  readAllChatMessages: (chatId) => API.put(`chat/read-messages/${chatId}`),
  fixMessage: (id) => API.put(`chat/fix-message/${id}`),

  updateChatTitle: (id, params) => {
    if (cancelToken.updateChatTitle) {
      cancelToken.updateChatTitle.cancel(
        'Previous request canceled due to new request.',
      )
    }

    cancelToken.updateChatTitle = axios.CancelToken.source()

    return API.put(`chat/update-chat/${id}`, params, {
      headers: getHeaders().headers,
      cancelToken: cancelToken.updateChatTitle.token,
    })
  },

  updateChatImage: (id, params, config = {}) =>
    API.post(`chat/update-chat-avatar/${id}`, params, {
      ...config,
      headers: getHeaders().headers,
    }),
  // mode — только для личного чата: 'self' (удалить у меня) или 'both' (у меня и у собеседника)
  removeChat: (id, mode) =>
    API.delete(`chat/remove-chat/${id}`, mode ? { params: { mode } } : undefined),
  removeMessage: (id) => API.delete(`chat/remove-message/${id}`),
  toggleMessageReaction: (messageId, reaction) =>
    API.post(`chat/toggle-message-reaction/${messageId}`, { reaction }),
  fixChat: (id) => API.put(`chat/fix-chat/${id}`),
  updateRoleMember: (id, params) => API.put(`chat/update-member/${id}`, params),
  addMessageFile: (id, params, config) =>
    API.post(`chat/add-message-file/${id}`, params, config),
  unFixMessage: (messageId) => API.put(`chat/unfix-message/${messageId}`),
  unFixChat: () => API.put(`chat/unfix-chat`),
  mute: (id) => API.post(`chat/mute?id=${id}`),
  unmute: (id) => API.post(`chat/unmute?id=${id}`),
  setExternalNotificationMuted: (id, channel, muted) =>
    API.post(`chat/set-external-notification-muted?id=${id}`, {
      channel,
      muted,
    }),
  read: (id, params) => API.post(`chat/read?id=${id}`, params),
  getWelcomeMessages: (params) =>
    API.get(`chat/get-welcome-messages/${getParams(params)}`),
  createWelcomeMessage: (params) =>
    API.post(`chat/create-welcome-message`, params),
  saveAutoGroup: (params) => API.post(`chat/save-auto-group`, params),
  updateChatHideHistory: ({ chatId, ...params }, cancelToken) =>
    API.post(`chat/update-chat-hide-history?id=${chatId}`, params, {
      headers: getHeaders().headers,
      cancelToken: cancelToken?.token,
    }),
  updateChatGeneralEnabled: ({ chatId, ...params }, cancelToken) =>
    API.post(`chat/update-chat-general-enabled?id=${chatId}`, params, {
      headers: getHeaders().headers,
      cancelToken: cancelToken?.token,
    }),
  getChatFolders: () => API.get(`chat/folder-list`),
  updateOrCreateChatFolder: (params) => API.post(`chat/save-folder`, params),
  deleteChatFolder: (id) => API.delete(`chat/delete-folder/${id}`),
  searchMessages: (params, cancelToken) =>
    API.get(`chat/search-messages`, {
      params,
      cancelToken: cancelToken?.token,
    }),
  getUserChatNameList: (params) =>
    API.get(`chat/get-users-chat-name-list`, { params }),
  getSupportChats: (params = {}, cancelToken) =>
    API.get(`chat/support-chats`, {
      params,
      cancelToken: cancelToken?.token,
    }),
  getAvailableForForward: (params = {}, signal) =>
    API.get(`chat/available-for-forward`, { params, signal }),
  forwardMessages: (params) =>
    API.post(`chat/forward-messages`, params, {
      skipGlobalErrorAlert: true,
    }),
  getSupportChatStatuses: () => API.get(`chat/support-chat-statuses`),
  saveSupportChatStatus: (params) =>
    API.post(`chat/save-support-chat-status`, params),
  deleteSupportChatStatus: (id) =>
    API.delete(`chat/delete-support-chat-status/${id}`),
  setSupportChatStatus: (chatId, params) =>
    API.post(`chat/set-support-chat-status/${chatId}`, params),
  assignSupportTicketManager: (chatId, params) =>
    API.post(`chat/assign-support-ticket-manager/${chatId}`, params),
  closeSupportTicket: (chatId) =>
    API.post(`chat/close-support-ticket/${chatId}`),
  openSupportTicket: (chatId) =>
    API.post(`chat/open-support-ticket/${chatId}`),
  messageContext: (params, cancelToken) =>
    API.get(`chat/message-context`, {
      params,
      cancelToken: cancelToken?.token,
    }),
}

export const notificationChatTypesApi = {
  getAll: () => API.get('notification-chat-type'),
  save: (params) => API.post('notification-chat-type/save', params),
  remove: (id) => API.delete(`notification-chat-type/delete/${id}`),
  updateOrder: (items) =>
    API.post('notification-chat-type/update-order', { items }),
}

export const classApi = {
  index: (conf) => API.get(`classes${getParams(conf)}`),
  getClassesById: (folderId) => API.get(`classes?folder_id=${folderId}`),
  getClassesByDirection: (directionId) =>
    API.get(`classes?direction_id=${directionId}`),
  getClassesAndFolders: (params) =>
    API.get(`classes/get-classes-info/${getParams(params)}`),
  show: (id, conf) => API.get(`classes/show/${id}${getParams(conf)}`),
  showByUser: (userId) => API.get(`classes/show-by-user?userId=${userId}`),
  showForPayment: (conf) =>
    API.get(`classes/show-for-payment${getParams(conf)}`),
  create: (params) => API.post(`classes/create`, params),
  update: (id, params) => API.post(`classes/update/${id}`, params),
  delete: (id, options) => {
    const deleteGroupsParam = options
      ? `?delete_groups=${options.deleteGroups ? 1 : 0}`
      : ''
    return API.delete(`classes/delete/${id}${deleteGroupsParam}`)
  },
  deletePreview: (id) => API.get(`classes/delete-preview/${id}`),
  attachChildren: (id, params) =>
    API.post(`classes/attach-children/${id}`, params),
  detachChildren: (id, params) =>
    API.post(`classes/detach-children/${id}`, params),
  transferPaidClass: (params) => API.post('classes/transfer-paid-class', params),
  attachUserClassGroup: (id, params) =>
    API.post(`classes/attach-user-class-group/${id}`, params),
  detachUserClassGroup: (id, params) =>
    API.post(`classes/detach-user-class-group/${id}`, params),
  changePriceForChild: (params) =>
    API.post('classes/change-price-for-child', params),
  changeDiscountForChild: (params) =>
    API.post('classes/change-discount-for-child', params),
  updatePaymentIdentifierForChild: (params) =>
    API.post('classes/update-payment-identifier-for-child', params),
  createCopy: (data) => API.post('/classes/create-copy', data),
  massPaymentAmountUpdate: (data) =>
    API.post('/classes/mass-payment-amount-update', data),
  updateFolders: (data) => API.post('/classes/folders/bulk', data),
  updateCatalogFolders: (data) =>
    API.post('/classes/catalog-folders/bulk', data),
  getCatalog: (conf) =>
    API.get(`classes/catalog${getParams(conf)}`, {}, getHeaders()),
  getAutoChats: (id) => API.get(`classes/get-auto-chats/${id}`),
  syncAutoChats: (id, params) => API.post(`classes/sync-auto-chats/${id}`, params),
  addCourseToAllStudents: (id, params) =>
    API.post(`classes/add-course-to-all-students/${id}`, params),
  updClassSupervisor: (conf) =>
    API.put(
      `classes/update-supervisor/${conf.id}`,
      { supervisor_ids: conf.supervisor_ids },
      getHeaders(),
    ),

  folders: () => API.get('/class-folder'),
  addFolder: (params) => API.post('/class-folder/add-new', params),
  editFolder: (idFolder, params) =>
    API.put(`/class-folder/rename/${idFolder}`, params),
  deleteFolder: (id, confirmation) => API.delete(`/class-folder/delete/${id}`, deletionConfirmationConfig(confirmation)).then(ensureApiSuccess),
  sorting: (conf) => API.post(`/classes-sorting`, conf.data),
  enroll: (data) => API.post(`classes/enroll-class`, data),
}

export const languagesApi = {
  save: (params) => API.post(`languages/save-settings`, params),
}

export const news = {
  get: (id) => API.get(`news/view/${id}`),
  getAll: () => API.get(`news`),
  create: () => API.post(`news/draft-or-new`),
  delete: (id) => API.post(`news/delete/${id}`),
  save: (id, param) => API.post(`news/save/${id}`, param),
  createBlock: (newsId) => API.post(`news/new-block`, newsId),
  updateBlock: (id, param) => API.post(`news/update-block/${id}`, param),
  deleteBlock: (id) => API.delete(`news/delete-block/${id}`),
  createComment: (id, param) => API.post(`news/create-comment/${id}`, param),
  getComment: (id, first, last) =>
    API.get(`news/comments/${id}?first=${first}&last=${last}`),
  toggleLike: (id) => API.post(`news/toggle-like/${id}`),
  deleteСomment: (id) => API.post(`news/delete-comment/${id}`),
  changeRank: (params) => API.post(`news/change-rank`, params),
}

export const departments = {
  getAll: (visible = 'default') => API.get(`/org-units?visible=${visible}`),
  getAllIndex: () => API.get(`/org-units/select-index`),

  departmentUpdate: (id, params) =>
    API({
      url: `org-units/update/${id}`,
      params,
      method: 'PUT',
    }),

  departmentUpdateAll: (params) => API.post(`/org-units/update-order`, params),

  create: (params) => API.post(`/org-units/create`, params),
  update: (id, params) => API.post(`org-units/update/${id}`, params),
  delete: (id) => API.delete(`org-units/delete/${id}`),
  addAnEmployeeToDepartment: (params) =>
    API.post(`/org-units/add-user`, params),

  utUsers: (id) => API.get(`org-units/users-list/${id}`),
  deleteEmployee: (params) =>
    API({ url: `org-units/remove-user/`, params, method: 'DELETE' }),

  userScriptorAdeptoDepartments: (id) =>
    API.get(`org-units/list-by-user/${id}`),
}

export const orgUnitAutomationRules = {
  getAll: () => API.get('/org-unit-automation-rule'),
  getOptions: () => API.get('/org-unit-automation-rule/get-options'),
  create: (params) => API.post('/org-unit-automation-rule/create', params),
  update: (id, params) => API.post(`/org-unit-automation-rule/update/${id}`, params),
  delete: (id) => API.delete(`/org-unit-automation-rule/delete/${id}`),
  updateOrder: (params) => API.post('/org-unit-automation-rule/update-order', params),
}

export const teams = {
  getAll: () => API.get(`/teams`),
  getAllIndex: () => API.get(`/teams/select-index`),

  teamUpdate: (id, params) =>
    API({
      url: `teams/update/${id}`,
      params,
      method: 'PUT',
    }),

  teamUpdateAll: (params) => API.post(`/teams/update-order`, params),

  create: (params) => API.post(`/teams/create`, params),
  update: (id, params) => API.post(`teams/update/${id}`, params),
  delete: (id) => API.delete(`teams/delete/${id}`),
  addAnEmployeeToTeam: (params) => API.post(`/teams/add-user`, params),

  utUsers: (id) => API.get(`teams/users-list/${id}`),
  deleteEmployee: (params) =>
    API({ url: `teams/remove-user/`, params, method: 'DELETE' }),

  userScriptorAdeptoDepartments: (id) => API.get(`teams/list-by-user/${id}`),
}

export const library = ({ basePath = 'confluence' }) => ({
  createSection: (params) => API.post(`${basePath}/new-header`, params),
  editSection: (id, data) =>
    API({
      url: `${basePath}/save-header/${id}`,
      data,
      method: 'PUT',
    }),
  editPage: (id, data) =>
    API({
      url: `/${basePath}/save-page/${id}`,
      data,
      method: 'PUT',
    }),
  editBlock: (id, data) => API.post(`/${basePath}/update-block/${id}`, data),
  createBlock: (params) => API.post(`/${basePath}/new-block`, params),
  detAll: (params) => API.get(`${basePath}`, params ? { params } : undefined),
  createPage: (params) => API.post(`${basePath}/draft-or-new`, params),
  getPage: (id) => API.get(`/${basePath}/view-page/${id}`),
  downloadCarousel: (id) => API.get(`/${basePath}/blocks/${id}/images/archive`, { responseType: 'blob' }),
  deleteBlock: (id) => API.delete(`/${basePath}/delete-block/${id}`),
  deleteSection: (id) => API.delete(`/${basePath}/delete-header/${id}`),
  deletePage: (id) => API.delete(`/${basePath}/delete-page/${id}`),
  changeRank: (data) =>
    API({
      url: `/${basePath}/change-rank`,
      data,
      method: 'PUT',
    }),
  changeRankSections: (data) =>
    API({
      url: `/${basePath}/change-rank-header`,
      data,
      method: 'PUT',
    }),
  changeRankPage: (data) =>
    API({
      url: `/${basePath}/change-rank-page`,
      data,
      method: 'PUT',
    }),
  createDepartmentInPage: (params) =>
    API.post(`/${basePath}/add-org-unit`, params),
  getPageUnits: (id) => API.get(`/${basePath}/page-units?pageId=${id}`),
  deleteDepartmentInPage: (params) =>
    API.post(`/${basePath}/remove-org-unit`, params),
  getAccess: (params) =>
    API({
      url: `/${basePath}/access`,
      params,
      method: 'GET',
    }),
  saveAccess: (data) =>
    API({
      url: `/${basePath}/access`,
      data,
      method: 'PUT',
    }),
  getShareLink: (params) =>
    API({
      url: `/${basePath}/share-link`,
      params,
      method: 'GET',
    }),
  saveShareLink: (data) =>
    API({
      url: `/${basePath}/share-link`,
      data,
      method: 'PUT',
    }),
  reissueShareLink: (data) =>
    API({
      url: `/${basePath}/share-link-reissue`,
      data,
      method: 'PUT',
    }),
  createTextFile: (params) => API.post(`/${basePath}/text-files`, params),
  editTextFile: (id, data) =>
    API({
      url: `/${basePath}/text-files/${id}`,
      data,
      method: 'PUT',
    }),
  deleteTextFile: (id) => API.delete(`/${basePath}/text-files/${id}`),
  // Совместное редактирование текстового файла: ошибки (409 при конфликте
  // версий, 403 по чужому тексту) обрабатывает сам редактор.
  getTextFileDocument: (id) =>
    API.get(`/${basePath}/text-file-document/${id}`, { skipGlobalErrorAlert: true }),
  saveTextFileChanges: (id, data) =>
    API.post(`/${basePath}/text-file-changes/${id}`, data, { skipGlobalErrorAlert: true }),
  getTextFileChanges: (id, since) =>
    API.get(`/${basePath}/text-file-changes/${id}`, { params: { since }, skipGlobalErrorAlert: true }),
  getTextFileHistory: (id, params) =>
    API.get(`/${basePath}/text-file-history/${id}`, { params, skipGlobalErrorAlert: true }),
  getTextFileHistoryEntry: (entryId) =>
    API.get(`/${basePath}/text-file-history-entry/${entryId}`, { skipGlobalErrorAlert: true }),
})

export const librarySharedLink = {
  get: (token, config) => API.get(`library/shared/${token}`, config),
  getEntity: (token, params) =>
    API.get(`library/shared/${token}/entity${getParams(params)}`),
  save: (token, data) =>
    API({
      url: `library/shared/${token}`,
      data,
      method: 'PUT',
    }),
}

export const lessonСompleted = {
  completed: (id, params) =>
    API.post(`topic-lesson/lesson-completed/${id}`, params),
}

export const rolesOrder = {
  create: (params) => API.post('auth/create-role', params),
  getList: () => API.get(`auth/list-roles-order`),
  listUpdate: (params) => API.post(`auth/update-roles-order`, params),
  nameUpdate: (params) => API.put(`auth/update-role-name`, params),
}

export const schoolAndUniversitySettings = {
  getAll: () => API.get(`direction/school-and-university`),
  update: (params) =>
    API.post(`direction/update-school-and-university`, params),
}

export const workingHours = {
  delete: (id) => API.delete(`work-hours/delete?id=${id}`),
  create: (params) => API.post(`work-hours/create`, params),
}

export const replenishmentSingleBalance = {
  replenish: (params) => API.post(`polymorph-payment/balance-deposit`, params),
  view: (conf) => API.get(`polymorph-payment/check-payment?id=${conf.id}`),
}

export const replenishmentBalanceAdditionalActivities = {
  replenish: (params) =>
    API.post(`polymorph-payment/additional-balance-deposit-v2`, params),
  getAcquiringOptions: (params) =>
    API.get(`polymorph-payment/additional-balance-acquiring-options`, {
      params,
    }),
  view: (conf) => API.get(`polymorph-payment/check-payment?id=${conf.id}`),
}

export const paymentUpdate = {
  update: () => API.post(`polymorph-payment/check-payment`),
}

export const surveyApi = {
  getAll: ({ params, ...conf }) =>
    API.get(`survey/get-all${getParams(conf)}`, getHeaders()),
  analyticsUsers: ({ params, ...conf }) =>
    API.get(`survey/analytics-users${getParams(conf)}`, getHeaders()),

  analytics: ({ params, id, ...conf }) =>
    API.get(
      `survey/get-survey-analytics${getParams(conf)}&id=${id}`,
      getHeaders(),
    ),

  answers: ({ params, surveyId, ...conf }) =>
    API.get(
      `survey/get-survey-results${getParams(conf)}&survey_id=${surveyId}`,
      getHeaders(),
    ),
  answersResend: ({ params, surveyId, ...conf }) =>
    API.get(
      `survey/get-survey-results-resend${getParams(
        conf,
      )}&survey_id=${surveyId}`,
      getHeaders(),
    ),

  responseRate: ({ id, out_app, uuid, assigned }) =>
    API.get(
      `survey/get-answers-analytics${getParams({
        id,
        out_app,
        uuid,
        assigned,
      })}`,
      getHeaders(),
    ),

  responseRateLoadMoreAnswers: ({ id, answerId, start, quantity }) =>
    API.get(
      `survey/response-rate-load-more-answers?id=${id}&answer_id=${answerId}&start=${start}&quantity=${quantity}`,
      getHeaders(),
    ),

  getUsersWithSentEmails: (id) =>
    API.get(`survey/get-users-with-sent-emails?id=${id}`, getHeaders()),

  getSettings: (id) => API.get(`survey/get-settings?id=${id}`, getHeaders()),

  getAllQuestions: (id) =>
    API.get(`survey/get-all-questions?id=${id}`, getHeaders()),

  view: (id) => API.get(`survey/get-view?survey_report_id=${id}`, getHeaders()),
  pass: (id) => API.get(`survey/get-pass?survey_report_id=${id}`, getHeaders()),
  passFollowingLink: (id) => API.get(`survey/get-pass?id=${id}`, getHeaders()),

  deleteSurvey: (id) => API.delete(`survey/delete?id=${id}`),
  deleteQuestion: (id) => API.delete(`survey/delete-question?id=${id}`),
  deleteWindow: (id) => API.delete(`/survey/delete-finish-window?id=${id}`),

  askSurvey: (id) => API.post(`survey/resend?survey_id=${id}`),
  cancelSurveySending: (params) =>
    API.post(`survey/cancel-survey-sending`, params),

  updateSettings: (params) => API.post(`survey/update-settings`, params),
  updateTask: (params) => API.post(`survey/update-task`, params),

  updateFinishWindow: (id, params) =>
    API.post(`survey/update-finish-window?id=${id}`, params),

  getAccess: (id) => API.get(`survey/get-availables?survey_id=${id}`),
  saveAccess: (params) => API.post(`survey/save-available`, params),
  createFinishWindow: (id) =>
    API.post(`survey/create-finish-window?survey_id=${id}`),
  getFinishWindows: (id) =>
    API.post(`survey/get-finish-windows?survey_id=${id}`),
  getFinishWindow: (id) => API.get(`/survey/get-finish-window?finish_id=${id}`),
  getUsers: (id) => API.get(`survey/get-extra-users?survey_id=${id}`),
  saveUser: (params) => API.post(`survey/save-extra-user`, params),

  takeSurvey: (params) => API.post(`survey/take-survey`, params),
  createReport: (query, params) =>
    API.post(`survey/create-report${query}`, params),
  create: (params) => API.post(`survey/create`, params),
  saveOrder: (params) => API.post(`survey/save-order`, params),
  saveOrderQuestions: (params) =>
    API.post(`survey/save-order-questions`, params),
  createTask: (params) => API.post(`survey/create-task`, params),
  answerOptions: (params) => API.post(`survey/answer-options`, params),

  getMysurvey: ({ params, ...conf }) =>
    API.get(`survey/get-my-survey${getParams(conf)}`, getHeaders()),

  getAttachedCourses: ({ params, ...conf }) =>
    API.get(`survey/get-attached-courses${getParams(conf)}`, getHeaders()),

  createCopy: (params) => API.post(`survey/create-copy`, params),
}

export const images = {
  getAccessCanvas: (params) => API.post(`common/return-image`, params),
}

export const mailingsApi = {
  save: (params) => API.post(`mailing/save-mailing`, params),
  get: (id) => API.get(`mailing/get-mailing-schedule?mailing_id=${id}`),
  getAll: (conf) =>
    API.get(`mailing/get-all-mailing/${getParams(conf)}`, getHeaders()),

  saveDateTime: (params) => API.post(`mailing/save-date-time`, params),
  saveBlocks: (params) => API.post(`mailing/save-blocks`, params),
  saveBlock: (params) => API.post(`mailing/save-block`, params),
  getBlocks: (id) => API.get(`mailing/get-blocks?mailing_id=${id}`),
  deleteBlock: (id) => API.get(`mailing/delete-block?id=${id}`),
  deleteMailing: (params) => API.post(`mailing/delete-mailing`, params),
  getAccess: (id) => API.get(`mailing/get-availables?mailing_id=${id}`),
  getUsers: (id) => API.get(`mailing/get-extra-users?mailing_id=${id}`),
  saveUser: (params) => API.post(`mailing/save-extra-user`, params),
  saveAccess: (params) => API.post(`mailing/save-available`, params),
  sendTest: (params) => API.post(`mailing/send-test-mail`, params),
  resend: (id, emailProvider) =>
    API.post(
      `mailing/resend?mailing_id=${id}&email_provider=${encodeURIComponent(
        emailProvider,
      )}`,
    ),
}

export const massActionsApi = {
  make: (data) => API.post(`mass-actions/make`, data),
  changeStatus: (data) => API.post(`user/mass-change-status`, data),
  sendInvite: (data) => API.post(`user/mass-send-invite`, data),
  addCourses: (data) => API.post(`direction-orders/mass-enroll`, data),
  addClassesDirections: (data) => API.post(`classes/mass-enroll`, data),
  addDepartment: (data) => API.post(`user/mass-add-department`, data),
  removeDepartment: (data) => API.post(`user/mass-remove-department`, data),
  removeCourses: (data) => API.post(`direction-orders/mass-unenroll`, data),
  removeClasses: (data) => API.post(`classes/mass-unenroll`, data),
  classRenewal: (data) => API.post(`classes/mass-renewal`, data),
  coursesRenewal: (data) => API.post(`direction-orders/mass-renewal`, data),
}

export const paymentIntegrationApi = {
  getConfigs: () => API.get(`integration-configs`, getHeaders()),
  getConfig: (id) => API.get(`integration-configs/${id}`),
  putConfig: (id, data) => API.put(`integration-configs/update/${id}`, data),
  deleteConfig: (id) => API.delete(`integration-configs/${id}`),
  getAllIntegrations: () => API.get(`integration-configs/get-all`),
  getTelebosConfig: () => API.get(`integration-configs/get-telebos`),
}

export const kinescopeIntegrationApi = {
  getConfig: () => API.get(`integration-configs/get-kinescope`),
  activate: (data) => API.post(`integration-configs/connect-kinescope`, data),
}

export const bigBlueButtonIntegrationApi = {
  getConfig: () => API.get(`integration-configs/get-big-blue-button`),
  activate: (data) =>
    API.post(`integration-configs/connect-big-blue-button`, data),
  uploadPresentation: (data) =>
    API.post(`integration-configs/upload-big-blue-button-presentation`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  deletePresentation: () =>
    API.delete(`integration-configs/delete-big-blue-button-presentation`),
  getPresentationFile: () =>
    API.get(`integration-configs/get-big-blue-button-presentation-file`, {
      responseType: 'blob',
      skipGlobalErrorAlert: true,
    }),
  sync: (data) => API.post(`integration-configs/sync-big-blue-button`, data),
  createMeeting: (data) =>
    API.post(`integration-configs/create-big-blue-button-meeting`, data),
  importRecordings: (data) =>
    API.post(`integration-configs/import-big-blue-button-recordings`, data),
  importChatLinks: (data) =>
    API.post(`integration-configs/import-big-blue-button-chat-links`, data),
  importReports: (data) =>
    API.post(`integration-configs/import-big-blue-button-reports`, data),
  getReportStatus: (data) =>
    API.get(
      `integration-configs/get-report-status${getParams(data)}`,
      getHeaders(),
    ),
  getRoomLimits: () =>
    API.get(
      `integration-configs/get-big-blue-button-room-limits`,
      getHeaders(),
    ),
  getPermanentLinks: ({ page = 1, perPage = 20 } = {}) =>
    API.get(
      `integration-configs/get-big-blue-button-permanent-links?page=${page}&perPage=${perPage}`,
      getHeaders(),
    ),
  createPermanentLink: (data) =>
    API.post(
      `integration-configs/create-big-blue-button-permanent-link`,
      data,
      getHeaders(),
    ),
  updatePermanentLink: (id, data) =>
    API.put(
      `integration-configs/update-big-blue-button-permanent-link/${id}`,
      data,
      getHeaders(),
    ),
  deletePermanentLink: (id) =>
    API.delete(
      `integration-configs/delete-big-blue-button-permanent-link/${id}`,
      getHeaders(),
    ),
  getAutomationSettings: () =>
    API.get(
      `integration-configs/get-big-blue-button-automation-settings`,
      getHeaders(),
    ),
  saveAutomationSettings: (data) =>
    API.post(
      `integration-configs/save-big-blue-button-automation-settings`,
      data,
      getHeaders(),
    ),
}

export const university2035IntegrationApi = {
  getConfig: () => API.get('integration-configs/get-university2035', getHeaders()),
  save: (fields) => API.post('integration-configs/connect-university2035', { fields }, getHeaders()),
}

export const iprBooksIntegrationApi = {
  getConfig: () => API.get('integration-configs/get-ipr-books', getHeaders()),
  save: (fields) => API.post('integration-configs/connect-ipr-books', { fields }, getHeaders()),
  getAutoLoginUrl: () => API.get('ipr-books/autologin', getHeaders()),
}

export const university2035DigitalTraceApi = {
  trackVideoProgress: (data) =>
    API.post('university2035/digital-trace-video-progress', data, {
      ...getHeaders(),
      skipGlobalErrorAlert: true,
    }),
}

export const smsIntegrationApi = {
  getSms: () => API.get(`/integration-configs/get-sms`, getHeaders()),
  connectSms: (data) => API.post(`/integration-configs/connect-sms`, data),
  getToken: (data) => API.post(`/auth/send-code`, data),
  getTokenRequiredNumberСonfirmation: (data) =>
    API.post(`/auth/send-conf-code`, data),
  confirmationCode: (data) => API.post(`/auth/conf-code`, data),
}

export const sendsayIntegrationApi = {
  getSendsay: () => API.get(`/integration-configs/get-sendsay`, getHeaders()),
  connectSendsay: (data) =>
    API.post(`/integration-configs/connect-sendsay`, data),
}

export const audienceApi = {
  getAll: () => API.get('/timetable-beta/audiences'),
  create: (data) => API.post('/timetable-beta/audiences', data),
  update: (id, data) => API.post(`/timetable-beta/audiences/${id}`, data),
  replaceInLessons: (id, data) =>
    API.post(`/timetable-beta/replace-audience/${id}`, data),
  remove: (id) => API.delete(`/timetable-beta/audiences/${id}`),
}

export const timetableBeta = {
  getGroupWeeklyPlan: (data, config = {}) =>
    API.post('/timetable-beta/group-weekly-plan', data, {
      ...config,
      skipGlobalErrorAlert: true,
    }),
  prepareLinkToMeeting: (data) =>
    API.post(`timetable-beta/prepare-link-to-meeting`, data),
  getWeeklyTimetableData: (data) =>
    API.post(`/timetable-beta/get-weekly-timetable-data`, data), //используется для получения одного дня чтобы отобразить плашку с сегодняшним уроком
  getWeeklyTimetableDataСancel: (data) => {
    if (cancelToken.timetableGetData)
      cancelToken.timetableGetData.cancel(
        'Previous request canceled due to new request.',
      )
    cancelToken.timetableGetData = axios.CancelToken.source()

    return API.post(`/timetable-beta/get-weekly-timetable-data`, data, {
      headers: getHeaders().headers,
      cancelToken: cancelToken.timetableGetData.token,
    })
  },

  getDailyTimetableDataСancel: (data, days) => {
    if (cancelToken.timetableGetData)
      cancelToken.timetableGetData.cancel(
        'Previous request canceled due to new request.',
      )
    cancelToken.timetableGetData = axios.CancelToken.source()

    const config = {
      headers: getHeaders().headers,
      cancelToken: cancelToken.timetableGetData.token,
    }
    if (days) {
      return Promise.all(days.map((day) =>
        API.post(`/timetable-beta/get-daily-timetable-data`, { ...data, day }, config),
      ))
    }
    return API.post(`/timetable-beta/get-daily-timetable-data`, data, config)
  },

  getFreeOrBusyWorkingHoursEmployees: (params) => {
    if (cancelToken.getFreeOrBusyWorkingHoursEmployees) {
      cancelToken.getFreeOrBusyWorkingHoursEmployees.cancel(
        'Previous request canceled due to new request.',
      )
    }

    cancelToken.getFreeOrBusyWorkingHoursEmployees = axios.CancelToken.source()

    return API.get(
      `timetable-beta/get-free-or-busy-working-hours-employees/${getParams(
        params,
      )}`,
      {
        headers: getHeaders().headers,
        cancelToken: cancelToken.getFreeOrBusyWorkingHoursEmployees.token,
      },
    )
  },

  addLesson: (data, config) => API.post(`/timetable-beta/add`, data, config),
  checkConflicts: (data) => API.post(`/timetable-beta/check-conflicts`, data, {
    skipGlobalErrorAlert: true,
  }),
  copyLesson: (data, config) => API.post(`/timetable-beta/copy`, data, config),
  swapLessons: (data) =>
    API.post(`/timetable-beta/swap-lessons`, data, {
      skipGlobalErrorAlert: true,
    }).then(ensureApiSuccess),
  getSwapLessonsOperation: (id) =>
    API.get(`/timetable-beta/swap-lessons-operation/${id}`, {
      skipGlobalErrorAlert: true,
    }).then(ensureApiSuccess),
  getGroupsAndClasses: (conf) =>
    API.get(
      `timetable-beta/get-groups-and-classes${getParams(conf)}`,
      getHeaders(),
    ),
  massDeletion: (data) =>
    API.post(`/timetable-beta/mass-deletion`, data, {
      skipGlobalErrorAlert: true,
    }).then(ensureApiSuccess),
  getAnalytics: (conf) =>
    API.get(`/timetable-beta/analytics${getParams(conf)}`),
  getMembersFromReport: (conf) =>
    API.get(`/timetable-beta/get-members-from-report${getParams(conf)}`),
  getTimetablePlanning: (conf) =>
    API.get(`/timetable-beta/planning${getParams(conf)}`),
  getReport: (conf) => API.get(`/timetable-beta/get-report${getParams(conf)}`),
  getOpenLessonPurchaseQuote: (conf) =>
    API.get(`/timetable-beta/open-lesson-purchase-quote${getParams(conf)}`),
  getReports: (conf) =>
    API.get(`/timetable-beta/get-reports${getParams(conf)}`),
  changePlan: (data) => {
    if (cancelToken.timetableChangePlan)
      cancelToken.timetableChangePlan.cancel(
        'Previous request canceled due to new request.',
      )
    cancelToken.timetableChangePlan = axios.CancelToken.source()

    return API.post(`/timetable-beta/change-plan`, data, {
      headers: getHeaders().headers,
      cancelToken: cancelToken.timetableChangePlan.token,
    })
  },
  getStudentsBygroups: (params) =>
    API.get(`/timetable-beta/get-students-by-groups`, { params }),

  edit: (data, config) => API.post(`/timetable-beta/edit`, data, config),
  createPlan: (data) => API.post(`/timetable-beta/create-plan`, data),
}
export const telegramBotIntegrationApi = {
  checkIsActive: (params) =>
    API.get(`telegram-bot/check-is-active/${getParams(params)}`),
  activate: (params) => API.post(`telegram-bot/activate`, params),
  chatMessage: (params) => API.post(`telegram-bot/chat-message`, params),
}


export const maxBindingApi = {
  checkIsActive: (params) => API.get(`max/check-is-active${getParams(params)}`),
  startActivation: (params) => API.post('max/start-activation', params),
  activate: (params) => API.post('max/activate', params),
  detachUser: (params) => API.post('max/detach-user', params),
}

export const wazzupIntegrationApi = {
  activate: (params) => API.post(`integration-wazzup/activate`, params),
  delete: (id_wazzup) =>
    API.delete(`integration-wazzup/delete?id=${id_wazzup}`),
  info: () => API.get(`integration-wazzup/index`),
  getFields: () =>
    API.get(`integration-configs/get-fields?integration_name=wazzup`), // @deprecated

  getBlocks: () => API.get(`wazzup-channels/blocks`),
  createDraft: (params) => API.post(`wazzup-channels/create-draft`, params),
  generateIframe: (params) =>
    API.post(`wazzup-channels/generate-iframe`, params),
  attachChannel: (params) => API.post(`wazzup-channels/attach`, params),
  updateChannel: (data) => API.post(`wazzup-channels/update-channel`, data),
  deleteChannel: (data) => API.post(`wazzup-channels/delete`, data),

  generateChatIframe: (params) =>
    API.post(`wazzup-chat/generate-iframe`, params),
  generateGlobalChatIframe: (params) =>
    API.post(`wazzup-chat/global-chats-iframe`, params),
}

export const userGoalsApi = {
  index: (data) => API.get(`user-goals/index${getParams(data)}`),
  remove: (data) => API.delete(`user-goals/delete`, { data }),
  update: (data) => API.post(`user-goals/update`, data),
  create: (data) => API.post(`user-goals/create`, data),
}

export const userNotesApi = {
  index: (data) => API.get(`user-notes/index${getParams(data)}`),
  remove: (data) => API.delete(`user-notes/delete`, { data }),
  update: (data) => API.post(`user-notes/update`, data),
  create: (data) => API.post(`user-notes/create`, data),
}

export const crmTrafficChannelApi = {
  getAll: () => API.get('crm-traffic-channel/get-all-channels'),

  create: (data, config) =>
      API.post('crm-traffic-channel/insert-channel', data, config),

  updateMany: (channels, config) =>
    API.put('crm-traffic-channel/update-channels', channels, config),

  updateSorting: (items) =>
    API.post('crm-traffic-channel/update-channels-sorting', { items }),

  delete: (id, config) =>
      API.delete(`crm-traffic-channel/delete-channel?id=${id}`, config),

  getRules: (channelId) =>
    API.get(`crm-traffic-channel/get-rules?channel_id=${channelId}`),

  saveRules: (channelId, rules) =>
    API.post(`crm-traffic-channel/save-rules?channel_id=${channelId}`, {
      rules,
    }),
  saveFranchises: (channelId, data) =>
    API.put(`crm-traffic-channel/save-franchises?id=${channelId}`, data),
  updateLeadChannel: (leadId, channelId) =>
    API.post(`crm-lead/update-traffic-channel?lead_id=${leadId}`, {
      traffic_channel_id: channelId,
    }),
}

export const aiTutorApi = {
  getAll: (conf = {}) => API.get(`ai-tutor/index${getParams(conf)}`, getHeaders()),
  view: (conf) => API.get(`ai-tutor/view${getParams(conf)}`, getHeaders()),
  add: (conf) =>
    API.post(`ai-tutor/create`, conf.data, getHeaders(['FormData'])),
  upd: (conf) =>
    API.post(
      `ai-tutor/update${getParams({ id: conf.id })}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  remove: (conf) => API.delete(`ai-tutor/delete${getParams({ id: conf.id })}`, getHeaders()),
  preview: (conf) =>
    API.post(`ai-tutor/preview`, conf.data, getHeaders(['FormData'])),
  transcribeDescription: (conf) =>
    API.post(
      `ai-tutor/transcribe-description`,
      conf.data,
      getHeaders(['FormData']),
    ),
}

export const aiTutorChatApi = {
  getDialog: (conf) =>
    API.get(`ai-tutor/chat${getParams({ ...(conf.params ?? {}), tutor_id: conf.id })}`, getHeaders()),
  sendMessage: (conf) =>
    API.post(`ai-tutor/chat-message${getParams({ tutor_id: conf.id })}`, conf.data, getHeaders()),
  restart: (conf) =>
    API.post(`ai-tutor/chat-restart${getParams({ tutor_id: conf.id })}`, conf.data, getHeaders()),
}
